// src/styles/brand.generated.ts
var brand = {
  background: "#ffffff",
  foreground: "#191f28",
  card: "#ffffff",
  cardForeground: "#191f28",
  popoverForeground: "#191f28",
  primary: "#7517d6",
  primaryForeground: "#ffffff",
  primaryHover: "#5f16ab",
  primaryPressed: "#47167a",
  primaryText: "#5f16ab",
  secondary: "#9333ea",
  secondaryForeground: "#ffffff",
  muted: "#ececf0",
  mutedForeground: "#686273",
  accent: "#e9ebef",
  accentForeground: "#030213",
  destructive: "#e52222",
  destructiveForeground: "#ffffff",
  border: "#e2e8f0",
  input: "#e2e8f0",
  inputBackground: "#f3f3f5",
  switchBackground: "#cbced4",
  ring: "#7517d6",
  sidebar: "#ffffff",
  sidebarForeground: "#191f28",
  sidebarPrimary: "#7517d6",
  sidebarPrimaryForeground: "#ffffff",
  sidebarAccent: "#f8fafc",
  sidebarAccentForeground: "#0f172a",
  sidebarBorder: "#e2e8f0",
  sidebarRing: "#7517d6"
};

// src/styles/colors.styles.ts
function mix(hex, amount) {
  const target = amount > 0 ? 255 : 0;
  const ratio = Math.abs(amount);
  const channels = [1, 3, 5].map(
    (offset) => Number.parseInt(hex.slice(offset, offset + 2), 16)
  );
  return `#${channels.map(
    (channel) => Math.round(channel + (target - channel) * ratio).toString(16).padStart(2, "0")
  ).join("")}`;
}
var colors = {
  // Primary colors - globals.css 의 --primary 에서 옴
  primary: brand.primary,
  primaryDark: mix(brand.primary, -0.25),
  primaryLight: mix(brand.primary, 0.25),
  // Secondary colors - globals.css 의 --secondary 에서 옴
  secondary: brand.secondary,
  secondaryDark: mix(brand.secondary, -0.2),
  // Text colors (Tailwind gray scale)
  text: {
    primary: "#1f2937",
    // gray-800
    secondary: "#4b5563",
    // gray-600
    muted: "#9ca3af",
    // gray-400
    light: "#6b7280"
    // gray-500
  },
  // Background colors - 인쇄물 전용
  background: {
    white: "#ffffff",
    gray: "#f4f4f4",
    lightGray: "#f9fafb",
    // gray-50
    highlight: "#e9f4ff",
    // 연한 파란 배경
    tableHeader: "#e9f4ff",
    // 테이블 헤더 배경
    muted: "#fafcff",
    // 아주 연한 파란 배경
    card: "#f9fafb"
    // 카드/노트 배경
  },
  // Border colors - 인쇄물 전용 (border.primary 만 브랜드 색)
  border: {
    light: "#eef2f7",
    // 내부 테두리
    medium: "#dbe8f7",
    // 파란 계열 테두리
    dark: "#d1d5db",
    // gray-300
    primary: brand.primary,
    // 합계 하단 강조 테두리
    table: "#dbe8f7",
    // 테이블 외곽 테두리
    inner: "#eef2f7",
    // 테이블 내부 셀 테두리
    gray: "#e5e7eb"
    // gray-200
  },
  // Status colors
  status: {
    success: "#16a34a",
    warning: "#f59e0b",
    error: brand.destructive,
    // globals.css 의 --destructive 에서 옴
    info: "#0ea5e9"
  }
};

// src/styles/quoteTemplates.ts
var SANS = "'Noto Sans KR', 'Malgun Gothic', -apple-system, BlinkMacSystemFont, sans-serif";
var SERIF = "'Noto Serif KR', 'Nanum Myeongjo', 'Batang', serif";
var INK = "#1f2937";
var SLATE = "#334155";
var NAVY = "#1e3a5f";
var TEAL = "#0f6b6b";
var WINE = "#7c2d2d";
var DEFAULT_TEMPLATE = {
  accent: INK,
  accentLight: "#eef1f5",
  fontFamily: SANS,
  header: "split-underline",
  items: "grid",
  summary: "box",
  provider: "sidebar"
};
var QUOTE_TEMPLATES = [
  // 0~9 — 공급자 «세로 사이드바»형 10종
  DEFAULT_TEMPLATE,
  // 0
  { accent: SLATE, accentLight: "#eef1f5", fontFamily: SERIF, header: "centered-double", items: "horizontal", summary: "line", provider: "sidebar" },
  // 1
  { accent: NAVY, accentLight: "#e9eef5", fontFamily: SANS, header: "banner", items: "headerband", summary: "bar", provider: "sidebar" },
  // 2
  { accent: INK, accentLight: "#f0f1f3", fontFamily: SANS, header: "left-rule", items: "zebra", summary: "box", provider: "sidebar" },
  // 3
  { accent: SLATE, accentLight: "#eef1f5", fontFamily: SERIF, header: "minimal", items: "horizontal", summary: "line", provider: "sidebar" },
  // 4
  { accent: TEAL, accentLight: "#e6f2f2", fontFamily: SANS, header: "split-underline", items: "headerband", summary: "bar", provider: "sidebar" },
  // 5
  { accent: NAVY, accentLight: "#e9eef5", fontFamily: SERIF, header: "centered-double", items: "grid", summary: "box", provider: "sidebar" },
  // 6
  { accent: WINE, accentLight: "#f5ebeb", fontFamily: SANS, header: "banner", items: "zebra", summary: "line", provider: "sidebar" },
  // 7
  { accent: INK, accentLight: "#f0f1f3", fontFamily: SERIF, header: "left-rule", items: "grid", summary: "bar", provider: "sidebar" },
  // 8
  { accent: SLATE, accentLight: "#eef1f5", fontFamily: SANS, header: "minimal", items: "zebra", summary: "box", provider: "sidebar" },
  // 9
  // 10~14 — 공급자 «상단 라벨»형 5종 (추가)
  { accent: INK, accentLight: "#eef1f5", fontFamily: SANS, header: "split-underline", items: "grid", summary: "box", provider: "toplabel" },
  // 10
  { accent: NAVY, accentLight: "#e9eef5", fontFamily: SANS, header: "banner", items: "headerband", summary: "bar", provider: "toplabel" },
  // 11
  { accent: SLATE, accentLight: "#eef1f5", fontFamily: SERIF, header: "centered-double", items: "zebra", summary: "line", provider: "toplabel" },
  // 12
  { accent: TEAL, accentLight: "#e6f2f2", fontFamily: SANS, header: "left-rule", items: "horizontal", summary: "box", provider: "toplabel" },
  // 13
  { accent: WINE, accentLight: "#f5ebeb", fontFamily: SERIF, header: "minimal", items: "headerband", summary: "bar", provider: "toplabel" }
  // 14
];
function getQuoteTheme(templateId) {
  if (templateId == null || !Number.isInteger(templateId)) {
    return DEFAULT_TEMPLATE;
  }
  const idx = (templateId % QUOTE_TEMPLATES.length + QUOTE_TEMPLATES.length) % QUOTE_TEMPLATES.length;
  return QUOTE_TEMPLATES[idx] ?? DEFAULT_TEMPLATE;
}
function pickQuoteTemplateId(seed) {
  if (!seed) return 0;
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = hash * 31 + seed.charCodeAt(i) >>> 0;
  }
  return hash % QUOTE_TEMPLATES.length;
}

// src/styles/base.styles.ts
var fontStack = `'Pretendard Variable', 'Pretendard', 'Malgun Gothic', 'Apple SD Gothic Neo', 'Noto Sans KR', sans-serif`;
var baseStyles = {
  // Document wrapper
  document: {
    fontFamily: fontStack,
    fontSize: "14px",
    color: colors.text.primary,
    lineHeight: "1.5",
    backgroundColor: colors.background.white,
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale"
  },
  // Page wrapper
  wrapper: {
    position: "relative",
    // 절대 위치 자식 요소(도장, 직인 등)를 위한 positioning context
    maxWidth: "800px",
    margin: "0 auto",
    padding: "40px",
    backgroundColor: colors.background.white
  },
  // Header section
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "20px",
    borderBottom: `2px solid ${colors.border.primary}`,
    marginBottom: "30px"
  },
  // Logo text
  logo: {
    fontSize: "28px",
    fontWeight: "bold",
    color: colors.primaryDark,
    letterSpacing: "-0.5px"
  },
  // Document title
  documentTitle: {
    fontSize: "24px",
    fontWeight: "600",
    color: colors.text.primary,
    textAlign: "center",
    marginBottom: "30px"
  },
  // Section container
  section: {
    padding: "20px 0",
    borderBottom: `1px solid ${colors.border.light}`
  },
  // Section title
  sectionTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: colors.text.primary,
    marginBottom: "15px",
    paddingBottom: "8px",
    borderBottom: `1px solid ${colors.border.light}`
  },
  // Table styles
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "20px"
  },
  tableHeader: {
    backgroundColor: colors.background.tableHeader,
    padding: "12px 8px",
    textAlign: "left",
    fontSize: "13px",
    color: colors.text.secondary,
    fontWeight: "500",
    borderBottom: `1px solid ${colors.border.medium}`,
    borderTop: `1px solid ${colors.border.medium}`
  },
  tableHeaderCenter: {
    backgroundColor: colors.background.tableHeader,
    padding: "12px 8px",
    textAlign: "center",
    fontSize: "13px",
    color: colors.text.secondary,
    fontWeight: "500",
    borderBottom: `1px solid ${colors.border.medium}`,
    borderTop: `1px solid ${colors.border.medium}`
  },
  tableHeaderRight: {
    backgroundColor: colors.background.tableHeader,
    padding: "12px 8px",
    textAlign: "right",
    fontSize: "13px",
    color: colors.text.secondary,
    fontWeight: "500",
    borderBottom: `1px solid ${colors.border.medium}`,
    borderTop: `1px solid ${colors.border.medium}`
  },
  tableCell: {
    padding: "12px 8px",
    borderBottom: `1px solid ${colors.border.light}`,
    fontSize: "14px",
    color: colors.text.primary,
    verticalAlign: "middle"
  },
  tableCellCenter: {
    padding: "12px 8px",
    borderBottom: `1px solid ${colors.border.light}`,
    fontSize: "14px",
    color: colors.text.primary,
    textAlign: "center",
    verticalAlign: "middle"
  },
  tableCellRight: {
    padding: "12px 8px",
    borderBottom: `1px solid ${colors.border.light}`,
    fontSize: "14px",
    color: colors.text.primary,
    textAlign: "right",
    verticalAlign: "middle"
  },
  // Info row (label-value pair)
  infoRow: {
    display: "flex",
    marginBottom: "8px",
    alignItems: "flex-start"
  },
  infoLabel: {
    flex: "0 0 120px",
    color: colors.text.secondary,
    fontSize: "13px",
    fontWeight: "500"
  },
  infoValue: {
    flex: "1",
    color: colors.text.primary,
    fontSize: "14px",
    fontWeight: "400"
  },
  // Price highlight
  priceHighlight: {
    fontSize: "24px",
    fontWeight: "bold",
    color: colors.primaryDark
  },
  priceBox: {
    backgroundColor: colors.background.highlight,
    padding: "20px",
    borderRadius: "8px",
    textAlign: "center",
    marginBottom: "20px"
  },
  // Summary section (totals)
  summaryRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 0",
    fontSize: "14px"
  },
  summaryLabel: {
    color: colors.text.secondary
  },
  summaryValue: {
    fontWeight: "500",
    color: colors.text.primary
  },
  summaryTotal: {
    display: "flex",
    justifyContent: "space-between",
    padding: "12px 0",
    fontSize: "18px",
    fontWeight: "bold",
    borderTop: `2px solid ${colors.border.primary}`,
    marginTop: "10px"
  },
  // Provider info table (공급자 정보)
  providerTable: {
    width: "100%",
    borderCollapse: "collapse",
    border: `1px solid ${colors.border.medium}`
  },
  providerCell: {
    padding: "10px 12px",
    border: `1px solid ${colors.border.light}`,
    fontSize: "13px"
  },
  providerLabel: {
    backgroundColor: colors.background.gray,
    color: colors.text.secondary,
    fontWeight: "500",
    width: "100px"
  },
  // Notes section
  notes: {
    backgroundColor: colors.background.lightGray,
    padding: "15px",
    borderRadius: "4px",
    fontSize: "13px",
    color: colors.text.secondary,
    lineHeight: "1.6",
    whiteSpace: "pre-wrap"
  },
  // Footer
  footer: {
    marginTop: "40px",
    paddingTop: "20px",
    borderTop: `1px solid ${colors.border.light}`,
    textAlign: "center",
    fontSize: "12px",
    color: colors.text.muted
  },
  // Date display
  dateText: {
    fontSize: "14px",
    color: colors.text.secondary
  },
  // Company seal (직인)
  companySeal: {
    width: "80px",
    height: "80px",
    objectFit: "contain"
  },
  // Grid layouts
  twoColumnGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px"
  },
  // Blur effect for sensitive info
  blurred: {
    filter: "blur(4px)",
    userSelect: "none"
  }
};

// src/styles/innopay.styles.ts
var innopayStyles = `
@charset "utf-8";
/*font*/
@font-face {
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 400;
    src: local('Pretendard-Regular'),
    url('../fonts/Pretendard-Regular.woff') format('woff');
}
@font-face {
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 500;
    src: local('Pretendard-Medium'),
    url('../fonts/Pretendard-Medium.woff') format('woff');
}
@font-face {
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 700;
    src: local('Pretendard-Bold'),
    url('../fonts/Pretendard-Bold.woff') format('woff');
}
/* reset */
body,p,h1,h2,h3,h4,h5,h6,ul,ol,li,.side_cate,dt,dd,table,th,td,form,fieldset,legend,input,textarea,button,blockquote{margin:0;padding:0;text-size-adjust:none; word-break: keep-all;word-wrap: break-word;}
body,table{font-size: 14px;font-family: 'Pretendard', sans-serif; color:#333;letter-spacing:0em;vertical-align: middle;}
*{box-sizing: border-box;word-break: keep-all;word-wrap: break-word;}
body{background:#fff;text-size-adjust:none;width: 100%; height: 100%;line-height: 1.4;top: 0!important;}
fieldset,img,iframe,frame{border:0}
iframe{-webkit-overflow-scrolling: touch;overflow-y: auto;}
legend,caption{overflow:hidden;position:absolute;font-size:0;line-height:0;visibility:hidden}
h1,h2,h3,h4,h5,h6{font-size:1em}
img{-webkit-tap-highlight-color: rgba(0,0,0,0);-webkit-tap-highlight-color: transparent;}
img,input,textarea,fieldset{border:0 none;outline:none}
ul,ol,dl,li,dt,dd{list-style:none;margin:0;padding:0;}
em,address{font-style:normal}
a{color:#373e40;text-decoration:none;outline: none;}
a:link,a:visited,a:hover,a:active{text-decoration:none;outline: none;}
strong{font-weight:bold}
legend,hr,caption{display:none}
table{border-spacing:0;}
input,textarea,button,select,option{font-family: inherit; text-decoration: none;letter-spacing:0em; outline: 0;-webkit-tap-highlight-color:transparent;vertical-align: middle;}
article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block;}
select{text-indent:5px;}
ul{text-decoration:none;}
figure{margin:0;padding:0;}
html{width: 100%; height: 100%;}
/*\uAD6C\uAE00\uBC88\uC5ED \uAD00\uB828*/
.skiptranslate iframe{display:none;font-family: 'Pretendard', sans-serif;}
font{line-height: 1.3;display: inline-block;word-wrap:break-word;max-width: 100%;}

/*color*/
.orange{color:#ff6d0b!important;}
.red{color: #f42d2d!important;}
.blue{color:#004ddd!important;}

/*scoll bar*/
*{scrollbar-width: thin;scrollbar-color: #ccc #eee;}
/* form common */
input{height:30px;border:none;appearance:none;border-radius:0 8px 8px 0;font-weight: 500;font-size: 16px;padding-left: 1px;}
input::placeholder{ color: #888;font-weight: normal;}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {appearance:none;margin: 0;}
input[type=number]{-moz-appearance: textfield;}
input[type="password"]{text-security:disc;-webkit-text-security:disc;font-size: 11px;}
input[type="password"]::placeholder{font-size: 14px;}

/*radio*/
.p_dp_no{display: none;}
.input_type1{min-height: 30px;}
.input_type1.radio{display: flex;flex-wrap: wrap;align-items: center;min-height: unset;}
.radio_wrap{margin:10px 15px 0 0;}
input[type="radio"]+label{appearance:none;-webkit-tap-highlight-color:transparent;transition:all 0.25s cubic-bezier(.39,.71,.56,.98);font-size: 16px;padding-left:30px;margin-bottom: 0px;position:relative;cursor:pointer;display:inline-block;height:auto;line-height:24px;}
input[type="radio"]:not(:checked)+label{font-weight: 500;color:#888!important}
input[type="radio"]:checked+label{font-weight: 500;user-select:none;color:#222!important}
input[type="radio"]:not(:checked), input[type="radio"]:checked{ position:absolute;  left:-9999px;  visibility:hidden}
input[type="radio"]+label:before,  input[type="radio"]+label:after{ content:'';  position:absolute;  left:0;  top:0;  width:20px;  height:20px;  z-index:0;}
input[type="radio"]:not(:checked)+label:before{border-radius:50%;border:2px solid #ddd;}
input[type="radio"]:not(:checked)+label:hover:before{border: 2px solid #6e91d2;}
input[type="radio"]:not(:checked)+label:after{border-radius:50%;border:2px solid #ddd;z-index:-1;transform:scale(0);}
input[type="radio"]:checked+label:before{border-radius:50%;border:2px solid #0555dc;}
input[type="radio"]:checked+label:after{border-radius:50%;border:2px solid #0555dc;background-color:#0555dc;z-index:0;transform:scale(.53);}

/*check*/
.check_wrap{margin:10px 15px 0 0;}
.checks {line-height: 24px;font-weight: 500;display: inline-flex;align-items: center; appearance:none;-webkit-tap-highlight-color:transparent;}
.checks input[type="checkbox"] {position: absolute; width: 1px;height: 1px;padding: 0;margin: -1px;overflow: hidden;clip:rect(0,0,0,0); border: 0 }
.checks input[type="checkbox"] + label {display: inline-block;position: relative;cursor: pointer;user-select: none;font-size: 16px;line-height: 20px;padding: 2px 0 2px 30px;}
.checks input[type="checkbox"] + label:before {content: '';position: absolute;left: 0;top: 50%;width: 20px;height: 20px;line-height: 24px;margin-top:-12px;text-align: center;background: #fff; border: 2px solid #ddd; border-radius : 4px;background-position: center center;background-size: 8px;transition: all 0.2s ease-in-out;}
input[type="checkbox"] + label:hover:before {border: 2px solid #6e91d2;}
.checks input[type="checkbox"] + label:active:before, .checks input[type="checkbox"]:checked + label:active:before { box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px 1px 3px rgba(0,0,0,0.1); }
.checks input[type="checkbox"]:checked + label:before {content: '';background: #0555dc; border-color: #0555dc; background-image: url('../images/check.png'); background-repeat: no-repeat; background-size: 12px;background-position: center center;}

/*select */
select{appearance:none;-moz-appearance : none;}
select::-ms-expand {display: none;}
.select_type1{position:relative;height: 30px;}
.select_type1 select{z-index: 2;background-color: rgba(255, 255, 255, 0);font-weight: 500;width:100%;height: 30px;padding: 0 0 0 1px;border:none;border-radius:0;font-size:16px;color:#222;font-family: 'Pretendard', sans-serif;appearance:none;appearance: none;width:100%;position: absolute;top: 0;left: 0;text-indent: 0;}
.select_type1:after{z-index: 1; content:"";display:block;position:absolute;right:10px;top:50%;margin-top:-4px;width:14px;height:8px;background: url(../images/arrow_b_gray.png) no-repeat center;background-size:14px 8px;transition: all 0.4s ease-in-out;}
.on .select_type1:after{transform: rotate3d(1, 0, 0, 180deg);}
.input_section.on .input_section.s_select .select_type1:after{transform: none;}
.input_section .input_section.s_select.on .select_type1:after{transform: rotate3d(1, 0, 0, 180deg);}

/*btn*/
.button{background:#1AAB8A;color:#fff;border:none;position:relative;font-size:20px;padding:20px 20px;cursor:pointer;outline:none;}
.button:hover{background:#fff;color:#1AAB8A;}
.button:before,button:after{content:'';position:absolute;top:0;right:0;height:2px;width:0;background: #1AAB8A;}
.button:after{right:inherit;top:inherit;left:0;bottom:0;}
.button:hover:before,button:hover:after{width:100%;}
a.text_link{color:#004ddd; text-decoration: underline;}
.btn{font-size: 16px;line-height: 24px;min-height:40px;height:auto;text-align: center;justify-content: center; align-items: center;display: inline-flex;border:none; border-radius: 8px;font-weight: 500; -webkit-tap-highlight-color:transparent;color: #fff;padding:8px 12px;width: 100%;vertical-align: middle;transition: all 0.2s ease-in-out;}
.btn_m{font-size: 13px;line-height: 20px;min-height:30px;height:auto;text-align: center;justify-content: center;align-items: center;display: inline-flex;border:none; border-radius: 6px;font-weight: 500; -webkit-tap-highlight-color:transparent;color: #fff;padding:4px 12px;transition: all 0.2s ease-in-out;}
.btn_s{font-size: 12px;line-height: 18px;min-height:24px;height:auto;text-align: center;justify-content: center;align-items: center;display: inline-flex;border:none; border-radius: 4px;font-weight: 500; -webkit-tap-highlight-color:transparent;color: #fff; width:auto;padding:3px 12px;transition: all 0.2s ease-in-out;}
.btn_blue{background-color: #0555dc;}
.btn_blue:hover{background-color: #0444b0;}
.btn_blue:active{background-color: #0444b0;}
.btn_blue:focus{background-color: #0444b0;}
.btn_gray{background-color: #aaa;}
.btn_gray:hover{background-color: #888;}
.btn_gray:active{background-color: #888;}
.btn_gray:focus{background-color: #888;}
.btn_d_gray{background-color: #555;}
.btn_d_gray:hover{background-color: #444;}
.btn_d_gray:active{background-color: #444;}
.btn_d_gray:focus{background-color: #444;}
.btn_black{background-color: #222;}
.btn_black:hover{background-color: #111;}
.btn_black:active{background-color: #111;}
.btn_black:focus{background-color: #111;}
.btn_bd_gray{border:1px solid #ccc;color: #666;}
.btn_bd_gray:hover{border-color: #aaa;color: #444;}
.btn_bd_gray:active{border-color: #aaa;color: #444;}
.btn_bd_gray:focus{border-color: #aaa;color: #444;}
.btn_bd_d_gray{border:1px solid #aaa;color: #444;}
.btn_bd_d_gray:hover{border-color: #888;color: #222;}
.btn_bd_d_gray:active{border-color: #888;color: #222;}
.btn_bd_d_gray:focus{border-color: #888;color: #222;}
.btn_wrap{padding:20px 25px;width: 100%; position: absolute; bottom: 0; left: 0;z-index:10;display: flex;background-color: rgba(255,255,255,0.6);-webkit-backdrop-filter:blur(12px);backdrop-filter:blur(12px);}
.btn_wrap a{margin:0 5px;}
.btn_wrap.static{position: static;}

/*gnb*/
.gnb{width: 100%; height: 50px;padding:0 20px;background-color:#fff;display: flex;align-items: center;border-bottom: 1px solid #eee;}
.gnb .logo{flex: 1 1 auto;height: 24px;}
.gnb .logo img{height: 24px; width: auto;}
.gnb .kind{font-weight: 500;color:#004ddd;flex: 0 0 auto;font-size: 14px;flex: 0 0 auto;display: inline-flex;}
.gnb .kind img{margin-left: 6px;}
.gnb .kind .select_type1{width: auto;padding-right: 18px;height: 40px;}
.gnb .kind .select_type1 select{text-indent: 0;padding: 0;width:100%;font-size: 14px;font-weight: 500;color:#004ddd;height: 100%;}
.gnb .kind .select_type1 select option{padding: 5px;color: #222;font-size: 13px;}
.gnb .kind .for_size{display: none;}
.gnb .kind .select_type1:after{width:10px;height:6px;margin-top:-3px;top:50%;right:0px;background: url(../images/arrow_b_gray_s.png) no-repeat right center;background-size: 10px auto;}

/*\uAD6C\uAE00\uBC88\uC5ED*/
#google_translate_element{padding-right: 15px!important;flex: 0 0 auto;}
#google_translate_element .goog-te-gadget-simple{border: none!important;font-size: 14px;}
.goog-te-gadget-simple .VIpgJd-ZVi9od-xl07Ob-lTBxed{font-weight: 500!important;color: #666!important;font-family: 'Pretendard', sans-serif!important; }
#google_translate_element .goog-te-gadget-simple .goog-te-gadget-icon{width: 16px;height: auto;background-size: auto 16px;background-position: -55px 0!important;display: none!important;}
#google_translate_element .goog-te-gadget-simple > span > a.VIpgJd-ZVi9od-xl07Ob-lTBxed{margin-left: 2px;}
#google_translate_element .goog-te-gadget-simple > span > a > span:nth-child(3){display: none!important;}
#google_translate_element .goog-te-gadget-simple > span > a > img:nth-child(4){display: none!important;}
#google_translate_element .goog-te-gadget-simple > span > a > span:nth-child(5){display:inline-block;color: transparent!important;width:13px;background: url(../images/arrow_b_gray_s.png) no-repeat center;background-size: 10px auto;background-position:right center;}
.translated-ltr .receipt .info ul li div.info_title{width:auto!important;}
.translated-ltr .receipt_wrap .payment_input .input_section .input_title{width:auto!important;}

/*\uACB0\uC81C \uC815\uBCF4 \uC785\uB825*/
.payment_input{margin-bottom: 30px;}
.payment_input:last-child{margin-bottom: 0px;}
.payment_input .input_section{min-height:44px;margin-bottom: 20px;border-bottom:1px solid #ccc;background: #fff;transition: all 0.2s ease-in-out;position: relative;padding-top: 12px;}
.payment_input .input_section.on{border-bottom:1px solid #004ddd;}
.payment_input .input_section.has_btn{border:none;}
.payment_input .input_section:last-child{margin-bottom: 0;}
.payment_input .input_title{line-height: 20px;color:#888;font-size: 16px;position: absolute;top: 17px;left: 0;transition: all 0.2s ease-in-out;}
.payment_input .input_section:is(.on, .entered, .has_btn, .has_select) .input_title{top: 0px;font-size: 13px;line-height: 13px;}
.payment_input .input_section.on .input_title{color: #004ddd;}
.payment_input .input_title font{-webkit-line-clamp: 1;overflow: hidden;text-overflow: ellipsis;word-wrap:break-word;display: -webkit-box;-webkit-box-orient: vertical;height: 100%;}
.payment_input .input_section .card_num{color: #999;}
.payment_input .input_section .card_num input{width: 40px;padding: 0px;text-align: center;}
.payment_input .input_section .card_period {color:#999;padding-left: 12px;}
.payment_input .input_section .card_period input{width: 30px;padding: 0 3px;text-align: center;}
.payment_input .input_type1{opacity: 0;transition: all 0.3s ease-in-out;}
.payment_input .input_type1 input{width: 100%;}
.payment_input .input_section:is(.on, .entered, .has_btn) :is(.input_type_split, .input_type1){opacity: 1;}

/*\uC601\uC218\uC99D*/
.receipt_wrap{padding-bottom: 154px;position: relative;}
.receipt_wrap .receipt_con{max-width: 600px;margin: auto;}
.receipt_wrap .receipt{padding: 30px 30px 0px 30px;}
.receipt .info{padding: 40px 20px;
    background: url('../images/receipt_bg_tl.png'), url('../images/receipt_bg_tr.png'), url('../images/receipt_bg_bl.png'), url('../images/receipt_bg_br.png'), url('../images/receipt_bg_tm.png'), url('../images/receipt_bg_ml.png'), url('../images/receipt_bg_mr.png'), url('../images/receipt_bg_bm.png');
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, repeat-x, repeat-y, repeat-y, repeat-x;
    background-position: 0 0, 100% 0, 0 100%, 100% 100%, 20px 0, 0 20px, 100% 20px, 20px 100%;
    background-size: 20px;
    position: relative;
}
.receipt .info h3{flex:1 1 100%;color: #6e91d2;font-weight: 500;padding-bottom: 10px;}
.receipt .info ul{display:flex;flex-wrap:wrap;padding-bottom: 25px; border-bottom: 4px solid #f4f4f4; margin-bottom:25px;position: relative;}
.receipt .info ul:last-child{padding-bottom:0; border-bottom:none; margin-bottom:0px;}
.receipt .info ul li{display:flex;margin:0 0px 6px 0;flex: 1 1 50%;}
.receipt .info ul li:last-child{margin-bottom:0px;}
.receipt .info ul li div{flex:1 1 auto;font-weight: 500;color: #222;}
.receipt .info ul li div font{word-wrap: anywhere;}
.receipt .info ul li div.info_title{flex:0 0 64px;color:#888; font-weight: normal;margin-right: 5px;}
.receipt .info .goods-list li{font-size: 14px;line-height: 1.3;padding:0 0 5px 0;display: flex;flex:0 0 100%;}
.receipt .info .goods-list li.ladel{display: flex;height: 30px; align-items: center;height: 30px;color: #888;font-size: 13px;}
.receipt .info .goods-list li.ladel span{padding: 0 5px;}
.receipt .info .goods-list li.ladel span:first-child{flex: 1 1 auto;}
.receipt .info .goods-list li.ladel span:nth-child(3){flex: 0 0 40px;text-align: center;}
.receipt .info .goods-list li.ladel :is(span:nth-child(2), span:last-child){flex: 0 0 90px;text-align: right;}
.receipt .info .goods-list .goods-nm{color: #222;font-weight: 500;flex: 1 1 auto;padding: 0 5px;font-size:16px;}
.receipt .info .goods-list .ct{flex: 0 0 40px;padding: 0 5px;text-align: center;font-weight: normal;color: #666;}
.receipt .info .goods-list :is(.price, .price-sum){flex: 0 0 90px;padding: 0 5px;text-align: right;font-weight: normal;color: #666;}
.receipt .info .goods-list .price-sum{font-weight: bold;font-size: 16px;color: #222;}
.receipt .info ul.top{padding-bottom: 0;border-bottom: none;display: block;}
.receipt .info ul.top .price_wrap{padding: 18px 30px;margin-top: 20px;background: #f4f4f4;border-radius: 8px;}
.receipt .info ul.top div.time{margin-bottom: 0;}
.receipt .info ul.top div.time.blue{color: #6e91d2;}
.receipt .info ul.top div.time.red{color: #ee6a71;}
.receipt .info ul.top div.p_name{font-size: 16px;}
.receipt .info ul.top div.price_detail{font-size: 16px;display: inline-flex;justify-content: flex-end;align-items: center;}
.receipt .info ul.top div.price_detail span{font-size: 13px;padding-left: 2px;}
.receipt .info ul.top li.price_sum .info_title{line-height: 24px;}
.receipt .info ul.top li.price_sum div.price{font-size: 24px; line-height: 24px; color:#004ddd; font-weight: bold;display: inline-flex;justify-content: flex-end;align-items: center;}
.receipt .info ul.top li.price_sum div.price > span {padding: 2px 0 0 2px; font-size: 15px; line-height: 20px;color:#004ddd;font-weight: 500;}
.receipt .info ul.bottom li div{color: #666;}
.receipt .info ul.bottom li div.info_title{color: #888;}
.receipt .info .price_wrap div.info_title{color: #666;}
.receipt_wrap .notice{padding:10px 30px;}
.receipt_wrap .notice p{margin-bottom: 4px;}
.receipt_wrap .btn_wrap{flex-wrap: wrap;padding: 25px;position: fixed;}
.receipt_wrap .btn_wrap .payment_input{flex: 1 1 100%;margin:5px 5px 15px;display: flex;align-items: end;}
.receipt_wrap .btn_wrap .payment_input .input_section{flex: 1 1 auto;margin: 0;background: transparent;}
.receipt_wrap .btn_wrap .payment_input .input_section input{background: transparent;}
.receipt_wrap .btn_wrap .payment_input a{flex:0 0 60px;margin: 0;height: auto;display: inline-flex;align-items: center;justify-content: center; border-radius: 8px;margin-left: 10px;height: 40px;}
.receipt_wrap .btn_wrap .btn{flex: 0 0 calc(50% - 10px);}
.stamp{position: absolute;top: 30px; right: 0px;width: 100px; height: auto;opacity: 0.8;}
.sign img{width: 120px; height: auto;}
.receipt .info ul li.f_width{flex: 1 1 100%;}

/*\uD504\uB9B0\uD2B8*/
@media print {
    .receipt_wrap, .receipt_con{print-color-adjust: exact; }
    .btn_wrap{display: none;}
}

/*error*/
.error_notice{padding:50px 15px;display: flex;flex-direction: column;align-items: center;justify-content: center;min-height: 100%;}
.error_notice .con{font-size:16px;margin-bottom: 25px;display: flex;flex-direction: column;align-items: center;}
.error_notice .con #icon_error{width:120px;height:120px;margin-bottom: 30px;}
.error_notice p{font-weight: 500;margin-bottom: 5px;text-align: center;}
.error_notice .code{color: #ff6d0b;}
.error_notice .btn_wrap{max-width:400px;}

/**************************************************************************************************************/
/*pos2 \uC601\uC218\uC99D*/
@media screen
and (min-width : 1000px) and (max-width : 1280px) and (min-device-width : 927px){
.receipt_wrap{width:calc(100% - 400px);transform:scale(1.5);margin:0 200px;transform-origin : center 0}
.receipt_con{width: 600px;margin: auto;}
.receipt_wrap .payment_input .input_section .input_title{width: 100px;}
}
/*\uBAA8\uBC14\uC77C \uC804\uCCB4, \uD3F4\uB4DC\uD3F0*/
@media screen and (max-device-width : 906px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2), screen and (max-device-width : 1088px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2){
/*font*/
@font-face {
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 400;
    src: local('Pretendard-Medium'),
    url(../fonts/Pretendard-Medium.woff) format('woff');
}
@font-face {
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 500;
    src: local('Pretendard-SemiBold'),
    url(../fonts/Pretendard-SemiBold.woff) format('woff');
}
@font-face {
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 700;
    src: local('Pretendard-Bold'),
    url(../fonts/Pretendard-Bold.woff) format('woff');
}
.p_dp_no{display: block;}
.m_dp_no{display: none;}

h2{font-size: 20px;}
input{height: 38px;font-size: 18px;}
input[type="radio"] + label{font-size: 18px;}
.payment_input .input_section{min-height: 40px;}

/*gnb*/
.gnb{padding: 0 15px;position: fixed;top: 0;left: 0;width: 100%;z-index: 10;}
.gnb .logo{height: 20px;}
.gnb .logo img{height: 20px;}

/*\uACB0\uC81C \uC815\uBCF4 \uC785\uB825*/
.payment_input .input_title{top: 20px;font-size: 18px;}

/*btn*/
.btn_wrap{padding: 20px 10px;width: 100%;position: fixed; bottom: calc(env(safe-area-inset-bottom) + 0px); right: 0;}

/*receipt*/
.receipt_wrap{min-width: unset;padding-bottom: calc(env(safe-area-inset-bottom) + 160px);margin-top: 50px;}
.receipt_wrap .receipt{padding: 20px 15px 0;}
.receipt .info ul.top .price_wrap{padding: 18px 15px; }
.receipt .info ul li{flex: 1 1 100%;}
.receipt_wrap .notice{padding: 10px 15px 20px;}
.receipt_wrap .btn_wrap{padding: 20px 10px calc(env(safe-area-inset-bottom) + 20px);bottom: 0;}

/*error_notice*/
.error_notice{padding-bottom: calc(env(safe-area-inset-bottom) + 80px);margin-top: 50px;}
.error_notice .btn_wrap{max-width:unset;position: fixed;bottom: 0;padding-bottom: calc(env(safe-area-inset-bottom) + 20px);}

form{width: 100%;}

}/*\uBAA8\uBC14\uC77C \uC804\uCCB4 end*/

/*\uBAA8\uBC14\uC77C \uAC00\uB85C, \uD070 \uC138\uB85C*/
@media screen and (min-device-width : 360px) and (max-device-width : 906px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2), screen and (max-device-width : 1088px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2){
body, table{font-size: 16px;}
.btn{font-size: 18px;line-height: 24px;height: auto;padding: 13px 12px;min-height: 50px;}
.btn_s{font-size: 13px;line-height: 20px;height: auto;padding: 5px 12px;min-height: 30px;}
.btn_m{font-size: 15px;line-height: 22px;height: auto;padding: 9px 12px;min-height: 40px;}
#google_translate_element{padding-right: 10px!important;}
.receipt .info ul li{margin-bottom: 8px;}
.receipt .info ul li div.info_title{flex: 0 0 75px;}
.error_notice{padding-bottom: calc(env(safe-area-inset-bottom) + 90px);}
.error_notice .con{font-size: 18px;}
}/*\uBAA8\uBC14\uC77C \uAC00\uB85C, \uD070 \uC138\uB85C end*/

/*\uBAA8\uBC14\uC77C \uD070 \uC138\uB85C*/
@media screen and (max-device-width : 500px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2){
.receipt .info .goods-list .goods-nm{flex: 0 0 100%;margin-bottom: 5px;}
.receipt .info .goods-list li{flex-wrap:wrap;justify-content: flex-end;margin-bottom: 15px;}
}/*\uBAA8\uBC14\uC77C \uD070 \uC138\uB85C*/

/*\uBAA8\uBC14\uC77C \uC791\uC740 \uC138\uB85C*/
@media screen and (max-device-width : 359px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2){
h2{font-size: 18px;}
.gnb{flex-wrap: wrap;padding: 10px;justify-content: space-between;height: auto;position: static;}
.gnb .logo{flex: 1 1 100%;margin-bottom: 5px;}
.btn_wrap{padding: 20px 5px;}
.receipt_wrap{padding-bottom: calc(env(safe-area-inset-bottom) + 151px);margin-top: 0;}
.receipt_wrap .receipt{padding: 15px 10px;}
.receipt .info{padding: 20px 10px;}
.error_notice{margin-top: 0;}
}/*\uBAA8\uBC14\uC77C \uC791\uC740 \uC138\uB85C end*/
`;

// src/components/common/PdfDocument.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function PdfDocument({
  title,
  children,
  isPdf = true,
  additionalStyles = "",
  fontFamily
}) {
  const docFontFamily = fontFamily ?? baseStyles.document.fontFamily;
  const wrapperStyle = fontFamily ? { ...baseStyles.wrapper, fontFamily } : baseStyles.wrapper;
  const baseStyleString = `
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }

    html, body {
      font-family: ${docFontFamily};
      font-size: ${baseStyles.document.fontSize};
      line-height: ${baseStyles.document.lineHeight};
      color: ${baseStyles.document.color};
      background-color: ${baseStyles.document.backgroundColor};
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    @page {
      size: A4;
      margin: 12mm;
    }

    @media print {
      body {
        background: #fff;
        padding: 0;
      }

      .no-print {
        display: none !important;
      }
    }

    table {
      border-collapse: collapse;
      width: 100%;
    }

    ${additionalStyles}
  `;
  if (isPdf) {
    return /* @__PURE__ */ jsxs("html", { lang: "ko", children: [
      /* @__PURE__ */ jsxs("head", { children: [
        /* @__PURE__ */ jsx("meta", { charSet: "UTF-8" }),
        /* @__PURE__ */ jsx(
          "meta",
          {
            name: "viewport",
            content: "width=device-width, initial-scale=1.0"
          }
        ),
        /* @__PURE__ */ jsx("title", { children: title }),
        /* @__PURE__ */ jsx("style", { dangerouslySetInnerHTML: { __html: baseStyleString } })
      ] }),
      /* @__PURE__ */ jsx("body", { children: /* @__PURE__ */ jsx("div", { style: wrapperStyle, children }) })
    ] });
  }
  return /* @__PURE__ */ jsx("div", { style: wrapperStyle, children });
}

// src/utils/formatters.ts
function formatCurrency(amount) {
  return new Intl.NumberFormat("ko-KR").format(amount);
}
function formatCurrencyWithUnit(amount) {
  return `${formatCurrency(amount)}\uC6D0`;
}
function formatDateKorean(date) {
  const d = typeof date === "string" ? new Date(date) : date;
  const year = d.getFullYear();
  const month = d.getMonth() + 1;
  const day = d.getDate();
  return `${String(year)}\uB144 ${String(month)}\uC6D4 ${String(day)}\uC77C`;
}
function formatDateSlash(date) {
  const d = typeof date === "string" ? new Date(date) : date;
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${String(year)}/${month}/${day}`;
}
function formatDateISO(date) {
  const d = typeof date === "string" ? new Date(date) : date;
  const isoString = d.toISOString();
  return isoString.split("T")[0] ?? isoString.slice(0, 10);
}
function convertNumberToKorean(num) {
  if (num === 0) return "\uC601";
  if (num < 0) return "\uB9C8\uC774\uB108\uC2A4 " + convertNumberToKorean(-num);
  const units = ["", "\uB9CC", "\uC5B5", "\uC870", "\uACBD"];
  const digits = ["", "\uC77C", "\uC774", "\uC0BC", "\uC0AC", "\uC624", "\uC721", "\uCE60", "\uD314", "\uAD6C"];
  const positions = ["", "\uC2ED", "\uBC31", "\uCC9C"];
  let result = "";
  let unitIndex = 0;
  while (num > 0) {
    const chunk = num % 1e4;
    if (chunk > 0) {
      let chunkStr = "";
      let pos = 0;
      let temp = chunk;
      while (temp > 0) {
        const digit = temp % 10;
        if (digit > 0) {
          const digitStr = pos > 0 && digit === 1 ? "" : digits[digit] ?? "";
          const positionStr = positions[pos] ?? "";
          chunkStr = digitStr + positionStr + chunkStr;
        }
        temp = Math.floor(temp / 10);
        pos++;
      }
      result = chunkStr + (units[unitIndex] ?? "") + result;
    }
    num = Math.floor(num / 1e4);
    unitIndex++;
  }
  return result;
}
function formatAmountWithKorean(amount) {
  return `\uC77C\uAE08 ${convertNumberToKorean(amount)} \uC6D0\uC815`;
}
function formatBusinessNumber(num) {
  const cleaned = num.replace(/\D/g, "");
  if (cleaned.length !== 10) return num;
  return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(5)}`;
}
function formatPhoneNumber(phone) {
  const cleaned = phone.replace(/\D/g, "");
  if (/^01[016789]/.test(cleaned)) {
    if (cleaned.length === 10) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    if (cleaned.length === 11) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`;
    }
  }
  if (cleaned.startsWith("02")) {
    if (cleaned.length === 9) {
      return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 5)}-${cleaned.slice(5)}`;
    }
    if (cleaned.length === 10) {
      return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
    }
  }
  if (cleaned.length === 10) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  if (cleaned.length === 11) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`;
  }
  return phone;
}
function calculateVAT(subtotal) {
  return Math.round(subtotal * 0.1);
}
function calculateFromTotal(totalAmount) {
  const subtotal = Math.round(totalAmount / 1.1);
  const tax = totalAmount - subtotal;
  return { subtotal, tax };
}
function formatAddressLine(parts) {
  const street = (parts.streetAddress ?? "").trim();
  const region = [];
  for (const part of [parts.province, parts.city, parts.district]) {
    const value = (part ?? "").trim();
    if (!value || street.includes(value) || region.includes(value)) continue;
    region.push(value);
  }
  return [...region, street].filter(Boolean).join(" ");
}

// src/components/common/PdfHeader.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
function PdfHeader({
  logo = "SEMO",
  documentType,
  documentNumber,
  documentDate,
  rightContent
}) {
  const headerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    paddingBottom: "20px",
    borderBottom: `2px solid ${colors.primaryDark}`,
    marginBottom: "30px"
  };
  const leftSectionStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "8px"
  };
  const logoStyle = {
    fontSize: "28px",
    fontWeight: "bold",
    color: colors.primaryDark,
    letterSpacing: "-0.5px"
  };
  const documentInfoStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "4px"
  };
  const documentTypeStyle = {
    fontSize: "20px",
    fontWeight: "600",
    color: colors.text.primary
  };
  const documentMetaStyle = {
    fontSize: "13px",
    color: colors.text.secondary
  };
  const rightSectionStyle = {
    textAlign: "right",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "4px"
  };
  return /* @__PURE__ */ jsxs2("header", { style: headerStyle, children: [
    /* @__PURE__ */ jsxs2("div", { style: leftSectionStyle, children: [
      typeof logo === "string" ? /* @__PURE__ */ jsx2("div", { style: logoStyle, children: logo }) : logo,
      /* @__PURE__ */ jsxs2("div", { style: documentInfoStyle, children: [
        /* @__PURE__ */ jsx2("div", { style: documentTypeStyle, children: documentType }),
        documentNumber && /* @__PURE__ */ jsxs2("div", { style: documentMetaStyle, children: [
          "\uBB38\uC11C\uBC88\uD638: ",
          documentNumber
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxs2("div", { style: rightSectionStyle, children: [
      documentDate && /* @__PURE__ */ jsx2("div", { style: documentMetaStyle, children: formatDateKorean(documentDate) }),
      rightContent
    ] })
  ] });
}

// src/components/common/PdfSection.tsx
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
function PdfSection({
  title,
  children,
  showBorder = true,
  style,
  titleStyle
}) {
  const sectionStyle = {
    padding: "20px 0",
    borderBottom: showBorder ? `1px solid ${colors.border.light}` : "none",
    ...style
  };
  const defaultTitleStyle = {
    fontSize: "15px",
    fontWeight: "600",
    color: colors.text.primary,
    marginBottom: "15px",
    paddingBottom: "8px",
    borderBottom: `1px solid ${colors.border.light}`,
    display: "flex",
    alignItems: "center",
    gap: "8px",
    ...titleStyle
  };
  const titleIndicatorStyle = {
    width: "4px",
    height: "16px",
    backgroundColor: colors.primaryDark,
    borderRadius: "2px"
  };
  return /* @__PURE__ */ jsxs3("section", { style: sectionStyle, children: [
    title && /* @__PURE__ */ jsxs3("h3", { style: defaultTitleStyle, children: [
      /* @__PURE__ */ jsx3("span", { style: titleIndicatorStyle }),
      title
    ] }),
    /* @__PURE__ */ jsx3("div", { children })
  ] });
}

// src/components/common/PdfTable.tsx
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
function PdfTable({
  data,
  columns,
  emptyMessage = "\uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
  style,
  showRowNumber = false,
  rowNumberStart = 1
}) {
  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "20px",
    ...style
  };
  const getHeaderStyle = (align = "left") => ({
    backgroundColor: colors.background.tableHeader,
    padding: "12px 8px",
    textAlign: align,
    fontSize: "13px",
    color: colors.text.secondary,
    fontWeight: "500",
    borderBottom: `1px solid ${colors.border.medium}`,
    borderTop: `1px solid ${colors.border.medium}`
  });
  const getCellStyle = (align = "left") => ({
    padding: "12px 8px",
    borderBottom: `1px solid ${colors.border.light}`,
    fontSize: "14px",
    color: colors.text.primary,
    textAlign: align,
    verticalAlign: "middle"
  });
  const rowNumberHeaderStyle = {
    ...getHeaderStyle("center"),
    width: "50px"
  };
  const rowNumberCellStyle = {
    ...getCellStyle("center"),
    color: colors.text.secondary,
    fontWeight: "500"
  };
  const emptyRowStyle = {
    padding: "30px",
    textAlign: "center",
    color: colors.text.muted,
    fontSize: "14px"
  };
  const getCellValue = (row, key) => {
    if (typeof key === "string" && key.includes(".")) {
      return key.split(".").reduce((obj, k) => {
        if (obj && typeof obj === "object") {
          return Reflect.get(obj, k);
        }
        return void 0;
      }, row);
    }
    return Reflect.get(row, key);
  };
  return /* @__PURE__ */ jsxs4("table", { style: tableStyle, children: [
    /* @__PURE__ */ jsx4("thead", { children: /* @__PURE__ */ jsxs4("tr", { children: [
      showRowNumber && /* @__PURE__ */ jsx4("th", { style: rowNumberHeaderStyle, children: "No." }),
      columns.map((column) => /* @__PURE__ */ jsx4(
        "th",
        {
          style: {
            ...getHeaderStyle(column.align),
            width: column.width
          },
          children: column.header
        },
        String(column.key)
      ))
    ] }) }),
    /* @__PURE__ */ jsx4("tbody", { children: data.length === 0 ? /* @__PURE__ */ jsx4("tr", { children: /* @__PURE__ */ jsx4(
      "td",
      {
        colSpan: columns.length + (showRowNumber ? 1 : 0),
        style: emptyRowStyle,
        children: emptyMessage
      }
    ) }) : data.map((row, rowIndex) => /* @__PURE__ */ jsxs4("tr", { children: [
      showRowNumber && /* @__PURE__ */ jsx4("td", { style: rowNumberCellStyle, children: rowNumberStart + rowIndex }),
      columns.map((column) => {
        const value = getCellValue(row, column.key);
        const displayValue = column.render ? column.render(value, row, rowIndex) : (
          // eslint-disable-next-line @typescript-eslint/no-base-to-string
          String(value ?? "")
        );
        return /* @__PURE__ */ jsx4(
          "td",
          {
            style: getCellStyle(column.align),
            children: displayValue
          },
          String(column.key)
        );
      })
    ] }, rowIndex)) })
  ] });
}

// src/components/common/PdfInfoRow.tsx
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
function PdfInfoRow({
  label,
  value,
  labelWidth = "120px",
  style,
  highlight = false
}) {
  const rowStyle = {
    display: "flex",
    marginBottom: "8px",
    alignItems: "flex-start",
    ...style
  };
  const labelStyle = {
    flex: `0 0 ${typeof labelWidth === "number" ? `${String(labelWidth)}px` : labelWidth}`,
    color: colors.text.secondary,
    fontSize: "13px",
    fontWeight: "500",
    paddingRight: "10px"
  };
  const valueStyle = {
    flex: "1",
    color: highlight ? colors.primaryDark : colors.text.primary,
    fontSize: highlight ? "16px" : "14px",
    fontWeight: highlight ? "600" : "400"
  };
  return /* @__PURE__ */ jsxs5("div", { style: rowStyle, children: [
    /* @__PURE__ */ jsx5("span", { style: labelStyle, children: label }),
    /* @__PURE__ */ jsx5("span", { style: valueStyle, children: value })
  ] });
}

// src/components/common/PdfSummary.tsx
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
function PdfSummary({
  subtotal,
  tax,
  totalAmount,
  style,
  showCurrency = true
}) {
  const containerStyle = {
    marginTop: "20px",
    paddingTop: "20px",
    borderTop: `1px solid ${colors.border.light}`,
    ...style
  };
  const rowStyle = {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "8px 0",
    fontSize: "14px"
  };
  const labelStyle = {
    color: colors.text.secondary,
    marginRight: "20px",
    minWidth: "80px",
    textAlign: "right"
  };
  const valueStyle = {
    fontWeight: "500",
    color: colors.text.primary,
    minWidth: "120px",
    textAlign: "right"
  };
  const totalRowStyle = {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "12px 0",
    fontSize: "18px",
    fontWeight: "bold",
    borderTop: `2px solid ${colors.border.primary}`,
    marginTop: "10px"
  };
  const totalLabelStyle = {
    color: colors.text.primary,
    marginRight: "20px"
  };
  const totalValueStyle = {
    color: colors.primaryDark,
    minWidth: "120px",
    textAlign: "right"
  };
  const formatValue = (amount) => {
    const formatted = formatCurrency(amount);
    return showCurrency ? `${formatted}\uC6D0` : formatted;
  };
  return /* @__PURE__ */ jsxs6("div", { style: containerStyle, children: [
    /* @__PURE__ */ jsxs6("div", { style: rowStyle, children: [
      /* @__PURE__ */ jsx6("span", { style: labelStyle, children: "\uACF5\uAE09\uAC00\uC561" }),
      /* @__PURE__ */ jsx6("span", { style: valueStyle, children: formatValue(subtotal) })
    ] }),
    /* @__PURE__ */ jsxs6("div", { style: rowStyle, children: [
      /* @__PURE__ */ jsx6("span", { style: labelStyle, children: "\uBD80\uAC00\uC138" }),
      /* @__PURE__ */ jsx6("span", { style: valueStyle, children: formatValue(tax) })
    ] }),
    /* @__PURE__ */ jsxs6("div", { style: totalRowStyle, children: [
      /* @__PURE__ */ jsx6("span", { style: totalLabelStyle, children: "\uD569\uACC4\uAE08\uC561" }),
      /* @__PURE__ */ jsx6("span", { style: totalValueStyle, children: formatValue(totalAmount) })
    ] })
  ] });
}

// src/components/common/SealImage.tsx
import { Fragment, jsx as jsx7 } from "react/jsx-runtime";
function SealImage({
  url,
  style,
  fallback = null
}) {
  if (!url) return /* @__PURE__ */ jsx7(Fragment, { children: fallback });
  return /* @__PURE__ */ jsx7(
    "img",
    {
      src: url,
      alt: "",
      style,
      onError: (event) => {
        event.currentTarget.style.display = "none";
      }
    }
  );
}

// src/components/masked/MaskedSectionInline.tsx
import {
  MASK_BAR_COLOR,
  MASK_BAR_RADIUS,
  MASK_LOCK_GLYPH,
  MASK_SCALE,
  maskBarWidths
} from "@semo/shared-types/constants";
import { Fragment as Fragment2, jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
function LockGlyph({ width, height }) {
  const g = MASK_LOCK_GLYPH;
  return /* @__PURE__ */ jsxs7("svg", { width, height, viewBox: g.viewBox, fill: "none", children: [
    /* @__PURE__ */ jsx8(
      "path",
      {
        d: g.shackle,
        stroke: "currentColor",
        strokeWidth: g.shackleWidth,
        strokeLinecap: "round"
      }
    ),
    /* @__PURE__ */ jsx8("rect", { ...g.body, fill: "currentColor" }),
    /* @__PURE__ */ jsx8("circle", { ...g.keyholeCircle, fill: "#FFFFFF" }),
    /* @__PURE__ */ jsx8("rect", { ...g.keyholeStem, fill: "#FFFFFF" })
  ] });
}
function MaskedSectionInline({
  isMasked = false,
  message,
  scale = "document",
  barCount = 4,
  showLock = true,
  children
}) {
  if (!isMasked) {
    return /* @__PURE__ */ jsx8(Fragment2, { children });
  }
  const s = MASK_SCALE[scale];
  const widths = maskBarWidths(barCount);
  return /* @__PURE__ */ jsxs7("div", { style: { position: "relative", width: "100%" }, children: [
    /* @__PURE__ */ jsx8(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: s.gap,
          padding: `${s.paddingY}px ${s.paddingX}px`
        },
        children: widths.map((width, i) => /* @__PURE__ */ jsx8(
          "div",
          {
            style: {
              width,
              height: s.barHeight,
              background: MASK_BAR_COLOR,
              borderRadius: MASK_BAR_RADIUS
            }
          },
          i
        ))
      }
    ),
    /* @__PURE__ */ jsxs7(
      "div",
      {
        style: {
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: s.lockGap,
          textAlign: "center",
          color: s.textColor
        },
        children: [
          showLock && /* @__PURE__ */ jsx8(LockGlyph, { width: s.lockWidth, height: s.lockHeight }),
          /* @__PURE__ */ jsx8(
            "p",
            {
              style: {
                maxWidth: s.maxTextWidth,
                fontSize: s.fontSize,
                lineHeight: s.lineHeight,
                fontWeight: 500,
                margin: 0
              },
              children: message
            }
          )
        ]
      }
    )
  ] });
}

// src/components/quote/QuoteProviderTable.tsx
import { Fragment as Fragment3, jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
function QuoteProviderTable({
  provider,
  isBlur = false,
  accentColor,
  accentLight,
  variant = "sidebar"
}) {
  const isTopLabel = variant === "toplabel";
  const wrapperStyle = {
    marginBottom: "20px",
    border: `1px solid ${colors.border.table}`,
    borderRadius: "8px",
    overflowX: "auto"
  };
  const tableStyle = {
    width: "100%",
    minWidth: "500px",
    fontSize: "14px",
    borderCollapse: "collapse"
  };
  const topLabelStyle = {
    backgroundColor: accentColor ?? colors.primary,
    color: "#ffffff",
    padding: "6px 16px",
    fontWeight: 700,
    fontSize: "13px",
    letterSpacing: "0.1em",
    borderBottom: `1px solid ${colors.border.table}`
  };
  const sidebarCellStyle = {
    backgroundColor: accentLight ?? colors.background.tableHeader,
    width: "48px",
    textAlign: "center",
    fontWeight: 700,
    color: accentColor ?? colors.primary,
    borderRight: `1px solid ${colors.border.table}`,
    padding: 0,
    verticalAlign: "middle"
  };
  const sidebarInnerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    padding: "16px 0",
    lineHeight: "2",
    fontSize: "16px"
  };
  const labelCellStyle = {
    backgroundColor: colors.background.muted,
    whiteSpace: "nowrap",
    padding: "8px 16px",
    fontWeight: 700,
    color: colors.text.secondary,
    borderRight: `1px solid ${colors.border.inner}`,
    borderBottom: `1px solid ${colors.border.inner}`
  };
  const valueCellStyle = {
    padding: "8px 16px",
    color: colors.text.primary,
    fontWeight: 500,
    borderBottom: `1px solid ${colors.border.inner}`
  };
  const valueCellWithBorderStyle = {
    ...valueCellStyle,
    borderRight: `1px solid ${colors.border.inner}`
  };
  const nameLabelCellStyle = {
    ...labelCellStyle,
    width: "80px"
  };
  const nameValueCellStyle = {
    ...valueCellStyle,
    position: "relative"
  };
  const sealWrapperStyle = {
    position: "absolute",
    top: "50%",
    right: "16px",
    transform: "translateY(-50%)"
  };
  const sealStyle = {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    backgroundColor: "#f9f9f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "10px",
    color: colors.text.muted,
    overflow: "hidden",
    border: provider.companySealUrl ? "none" : `2px dashed ${colors.border.dark}`
  };
  const sealImageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "contain"
  };
  const lastRowLabelStyle = {
    ...labelCellStyle,
    borderBottom: "none"
  };
  const lastRowValueStyle = {
    ...valueCellStyle,
    borderBottom: "none"
  };
  const lastRowValueWithBorderStyle = {
    ...lastRowValueStyle,
    borderRight: `1px solid ${colors.border.inner}`
  };
  const smallTextStyle = {
    fontSize: "12px"
  };
  const certList = (provider.certifications ?? []).filter(Boolean);
  const hasCerts = certList.length > 0;
  const certText = certList.join(" \xB7 ");
  const bizRowLabelStyle = hasCerts ? labelCellStyle : lastRowLabelStyle;
  const bizRowValueWithBorderStyle = hasCerts ? valueCellWithBorderStyle : lastRowValueWithBorderStyle;
  const bizRowValueStyle = hasCerts ? valueCellStyle : lastRowValueStyle;
  const managerInfo = provider.managerName ? provider.managerPhone ? `${provider.managerName} (${formatPhoneNumber(provider.managerPhone)})` : provider.managerName : "-";
  return /* @__PURE__ */ jsx9(
    MaskedSectionInline,
    {
      isMasked: isBlur,
      scale: "document",
      barCount: 4,
      message: /* @__PURE__ */ jsxs8(Fragment3, { children: [
        "\uACF5\uAE09\uC0AC \uC815\uBCF4\uB294",
        /* @__PURE__ */ jsx9("br", {}),
        "\uACC4\uC57D \uD6C4\uC5D0 \uD655\uC778\uD560 \uC218 \uC788\uC5B4\uC694"
      ] }),
      children: /* @__PURE__ */ jsx9("div", { style: wrapperStyle, children: /* @__PURE__ */ jsx9("table", { style: tableStyle, children: /* @__PURE__ */ jsxs8("tbody", { children: [
        isTopLabel && /* @__PURE__ */ jsx9("tr", { children: /* @__PURE__ */ jsx9("td", { colSpan: 4, style: topLabelStyle, children: "\uACF5\uAE09\uC790" }) }),
        /* @__PURE__ */ jsxs8("tr", { children: [
          !isTopLabel && /* @__PURE__ */ jsx9("td", { rowSpan: hasCerts ? 5 : 4, style: sidebarCellStyle, children: /* @__PURE__ */ jsxs8("div", { style: sidebarInnerStyle, children: [
            /* @__PURE__ */ jsx9("span", { children: "\uACF5" }),
            /* @__PURE__ */ jsx9("span", { children: "\uAE09" }),
            /* @__PURE__ */ jsx9("span", { children: "\uC790" })
          ] }) }),
          /* @__PURE__ */ jsx9("td", { style: labelCellStyle, children: "\uB4F1\uB85D\uBC88\uD638" }),
          /* @__PURE__ */ jsx9("td", { colSpan: 3, style: valueCellStyle, children: /* @__PURE__ */ jsx9("span", { children: formatBusinessNumber(provider.businessNumber) }) })
        ] }),
        /* @__PURE__ */ jsxs8("tr", { children: [
          /* @__PURE__ */ jsx9("td", { style: labelCellStyle, children: "\uC0C1\uD638(\uBC95\uC778\uBA85)" }),
          /* @__PURE__ */ jsx9("td", { style: valueCellWithBorderStyle, children: provider.companyName }),
          /* @__PURE__ */ jsx9("td", { style: nameLabelCellStyle, children: "\uC131\uBA85" }),
          /* @__PURE__ */ jsxs8("td", { style: nameValueCellStyle, children: [
            /* @__PURE__ */ jsx9("span", { children: provider.representativeName }),
            /* @__PURE__ */ jsx9("div", { style: sealWrapperStyle, children: /* @__PURE__ */ jsx9("div", { style: sealStyle, children: /* @__PURE__ */ jsx9(
              SealImage,
              {
                url: provider.companySealUrl,
                style: sealImageStyle,
                fallback: "(\uC778)"
              }
            ) }) })
          ] })
        ] }),
        /* @__PURE__ */ jsxs8("tr", { children: [
          /* @__PURE__ */ jsx9("td", { style: labelCellStyle, children: "\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C" }),
          /* @__PURE__ */ jsx9("td", { colSpan: 3, style: { ...valueCellStyle, ...smallTextStyle }, children: /* @__PURE__ */ jsx9("span", { children: provider.address }) })
        ] }),
        /* @__PURE__ */ jsxs8("tr", { children: [
          /* @__PURE__ */ jsx9("td", { style: bizRowLabelStyle, children: "\uC5C5\uD0DC / \uC885\uBAA9" }),
          /* @__PURE__ */ jsx9("td", { style: { ...bizRowValueWithBorderStyle, ...smallTextStyle }, children: /* @__PURE__ */ jsx9("span", { children: provider.businessType ?? "-" }) }),
          /* @__PURE__ */ jsx9("td", { style: bizRowLabelStyle, children: "\uB2F4\uB2F9\uC790" }),
          /* @__PURE__ */ jsx9("td", { style: { ...bizRowValueStyle, ...smallTextStyle }, children: /* @__PURE__ */ jsx9("span", { children: managerInfo }) })
        ] }),
        hasCerts && /* @__PURE__ */ jsxs8("tr", { children: [
          /* @__PURE__ */ jsx9("td", { style: lastRowLabelStyle, children: "\uBCF4\uC720 \uC778\uC99D\uC11C" }),
          /* @__PURE__ */ jsx9(
            "td",
            {
              colSpan: 3,
              style: { ...lastRowValueStyle, ...smallTextStyle },
              children: /* @__PURE__ */ jsx9("span", { children: certText })
            }
          )
        ] })
      ] }) }) })
    }
  );
}

// src/components/quote/QuoteItemsTable.tsx
import { jsx as jsx10, jsxs as jsxs9 } from "react/jsx-runtime";
function QuoteItemsTable({
  items,
  showRowNumber = true,
  minRows = 5,
  accentLight,
  accentColor,
  variant = "grid"
}) {
  const isGrid = variant === "grid";
  const isBand = variant === "headerband";
  const isZebra = variant === "zebra";
  const vBorder = isGrid ? { borderRight: `1px solid ${colors.border.inner}` } : {};
  const wrapperStyle = {
    marginBottom: "20px",
    overflowX: "auto"
  };
  const tableStyle = {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    minWidth: "600px"
  };
  const headerCellBaseStyle = {
    backgroundColor: isBand ? accentColor ?? colors.text.primary : accentLight ?? colors.background.tableHeader,
    color: isBand ? "#ffffff" : colors.text.primary,
    padding: "8px 8px",
    textAlign: "center",
    fontWeight: 700,
    fontSize: "13px",
    borderTop: isBand ? "none" : `1px solid ${colors.border.table}`,
    borderBottom: isBand ? "none" : `1px solid ${colors.border.table}`,
    ...vBorder
  };
  const noHeaderStyle = {
    ...headerCellBaseStyle,
    width: "48px"
  };
  const nameHeaderStyle = {
    ...headerCellBaseStyle,
    padding: "8px 16px"
  };
  const smallHeaderStyle = {
    ...headerCellBaseStyle,
    width: "64px"
  };
  const priceHeaderStyle = {
    ...headerCellBaseStyle,
    width: "128px",
    padding: "8px 16px"
  };
  const dataCellBaseStyle = {
    padding: "8px 8px",
    fontSize: "13px",
    lineHeight: 1.4,
    borderBottom: `1px solid ${colors.border.inner}`,
    ...vBorder
  };
  const noDataStyle = {
    ...dataCellBaseStyle,
    textAlign: "center",
    color: colors.text.secondary
  };
  const nameDataStyle = {
    ...dataCellBaseStyle,
    padding: "8px 16px",
    textAlign: "left",
    color: colors.text.primary
  };
  const nameTextStyle = {
    fontWeight: 700,
    color: colors.text.primary
  };
  const quantityDataStyle = {
    ...dataCellBaseStyle,
    textAlign: "center",
    color: colors.text.primary,
    fontVariantNumeric: "tabular-nums"
  };
  const unitDataStyle = {
    ...dataCellBaseStyle,
    textAlign: "center",
    color: colors.text.secondary
  };
  const priceDataStyle = {
    ...dataCellBaseStyle,
    padding: "8px 16px",
    textAlign: "right",
    color: colors.text.primary,
    fontVariantNumeric: "tabular-nums"
  };
  const amountDataStyle = {
    ...priceDataStyle,
    fontWeight: 500
  };
  const emptyCellStyle = {
    ...dataCellBaseStyle
  };
  const emptyRowCount = Math.max(0, minRows - items.length);
  return /* @__PURE__ */ jsx10("div", { style: wrapperStyle, children: /* @__PURE__ */ jsxs9("table", { style: tableStyle, children: [
    /* @__PURE__ */ jsx10("thead", { children: /* @__PURE__ */ jsxs9("tr", { children: [
      showRowNumber && /* @__PURE__ */ jsx10("th", { style: noHeaderStyle, children: "No" }),
      /* @__PURE__ */ jsx10("th", { style: nameHeaderStyle, children: "\uD488\uBA85 \uBC0F \uADDC\uACA9" }),
      /* @__PURE__ */ jsx10("th", { style: smallHeaderStyle, children: "\uC218\uB7C9" }),
      /* @__PURE__ */ jsx10("th", { style: smallHeaderStyle, children: "\uB2E8\uC704" }),
      /* @__PURE__ */ jsx10("th", { style: priceHeaderStyle, children: "\uB2E8\uAC00(\uACF5\uAE09\uAC00\uC561)" }),
      /* @__PURE__ */ jsx10("th", { style: priceHeaderStyle, children: "\uACC4" })
    ] }) }),
    /* @__PURE__ */ jsxs9("tbody", { children: [
      items.map((item, index) => /* @__PURE__ */ jsxs9(
        "tr",
        {
          style: isZebra && index % 2 === 1 ? { backgroundColor: accentLight ?? colors.background.muted } : void 0,
          children: [
            showRowNumber && /* @__PURE__ */ jsx10("td", { style: noDataStyle, children: index + 1 }),
            /* @__PURE__ */ jsxs9("td", { style: nameDataStyle, children: [
              /* @__PURE__ */ jsx10("div", { style: nameTextStyle, children: item.name }),
              item.specification && /* @__PURE__ */ jsx10(
                "div",
                {
                  style: {
                    fontSize: "11px",
                    color: colors.text.muted,
                    marginTop: "2px",
                    lineHeight: 1.4
                  },
                  children: item.specification
                }
              )
            ] }),
            /* @__PURE__ */ jsx10("td", { style: quantityDataStyle, children: item.quantity }),
            /* @__PURE__ */ jsx10("td", { style: unitDataStyle, children: item.unit ?? "\uAC1C" }),
            /* @__PURE__ */ jsx10("td", { style: priceDataStyle, children: item.unitPrice.toLocaleString() }),
            /* @__PURE__ */ jsx10("td", { style: amountDataStyle, children: item.amount.toLocaleString() })
          ]
        },
        index
      )),
      Array.from({ length: emptyRowCount }).map((_, i) => /* @__PURE__ */ jsxs9("tr", { children: [
        showRowNumber && /* @__PURE__ */ jsx10("td", { style: { ...emptyCellStyle, padding: "8px 8px" }, children: "\xA0" }),
        /* @__PURE__ */ jsx10("td", { style: { ...emptyCellStyle, padding: "8px 16px" }, children: "\xA0" }),
        /* @__PURE__ */ jsx10("td", { style: { ...emptyCellStyle, padding: "8px 8px" }, children: "\xA0" }),
        /* @__PURE__ */ jsx10("td", { style: { ...emptyCellStyle, padding: "8px 8px" }, children: "\xA0" }),
        /* @__PURE__ */ jsx10("td", { style: { ...emptyCellStyle, padding: "8px 16px" }, children: "\xA0" }),
        /* @__PURE__ */ jsx10("td", { style: { ...emptyCellStyle, padding: "8px 16px" }, children: "\xA0" })
      ] }, `empty-${String(i)}`))
    ] })
  ] }) });
}

// src/components/quote/QuotePdfDocument.tsx
import { jsx as jsx11, jsxs as jsxs10 } from "react/jsx-runtime";
function QuotePdfDocument({
  data,
  isPdf = false,
  isBlur = false
}) {
  const {
    quoteNumber,
    quoteDate,
    provider,
    buyer,
    items,
    subtotal,
    tax,
    totalAmount,
    notes
  } = data;
  const totalAmountKorean = convertNumberToKorean(totalAmount);
  const theme = getQuoteTheme(data.templateId);
  const titleStyle = {
    fontSize: "32px",
    fontWeight: 900,
    letterSpacing: "0.2em",
    color: theme.accent,
    lineHeight: 1.25
  };
  const dateStyle = {
    fontSize: "13px",
    color: colors.text.muted
  };
  const renderHeader = () => {
    const title = /* @__PURE__ */ jsx11("h1", { style: titleStyle, children: "\uACAC \uC801 \uC11C" });
    const date = /* @__PURE__ */ jsxs10("div", { style: dateStyle, children: [
      "\uACAC\uC801\uC77C: ",
      quoteDate
    ] });
    switch (theme.header) {
      case "centered-double":
        return /* @__PURE__ */ jsxs10(
          "div",
          {
            style: {
              textAlign: "center",
              marginBottom: "20px",
              borderTop: `3px double ${theme.accent}`,
              borderBottom: `3px double ${theme.accent}`,
              padding: "12px 0"
            },
            children: [
              title,
              /* @__PURE__ */ jsxs10("div", { style: { ...dateStyle, marginTop: "4px" }, children: [
                "\uACAC\uC801\uC77C: ",
                quoteDate
              ] })
            ]
          }
        );
      case "banner":
        return /* @__PURE__ */ jsxs10(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: theme.accentLight,
              padding: "14px 20px",
              borderRadius: "6px",
              marginBottom: "20px"
            },
            children: [
              title,
              date
            ]
          }
        );
      case "left-rule":
        return /* @__PURE__ */ jsxs10(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              marginBottom: "20px",
              borderBottom: `1px solid ${colors.border.gray}`,
              paddingBottom: "16px"
            },
            children: [
              /* @__PURE__ */ jsx11("div", { style: { borderLeft: `5px solid ${theme.accent}`, paddingLeft: "14px" }, children: title }),
              date
            ]
          }
        );
      case "minimal":
        return /* @__PURE__ */ jsxs10("div", { style: { marginBottom: "24px" }, children: [
          title,
          /* @__PURE__ */ jsxs10("div", { style: { ...dateStyle, marginTop: "4px" }, children: [
            "\uACAC\uC801\uC77C: ",
            quoteDate
          ] })
        ] });
      case "split-underline":
      default:
        return /* @__PURE__ */ jsxs10(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              marginBottom: "20px",
              borderBottom: `2px solid ${theme.accent}`,
              paddingBottom: "16px"
            },
            children: [
              /* @__PURE__ */ jsx11("div", { children: title }),
              date
            ]
          }
        );
    }
  };
  const recipientLineStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginBottom: "20px",
    gap: "24px"
  };
  const recipientNameStyle = {
    borderBottom: `2px solid ${colors.text.primary}`,
    paddingBottom: "2px",
    paddingRight: "24px",
    display: "inline-block",
    minWidth: "140px"
  };
  const recipientNameTextStyle = {
    fontSize: "20px",
    fontWeight: 700,
    color: colors.text.primary,
    marginRight: "8px"
  };
  const recipientSuffixStyle = {
    fontSize: "16px",
    fontWeight: 400,
    color: colors.text.secondary
  };
  const totalAmountLineStyle = {
    textAlign: "right"
  };
  const totalAmountLabelStyle = {
    color: colors.text.secondary,
    fontSize: "14px",
    fontWeight: 700,
    marginRight: "12px"
  };
  const totalAmountKoreanStyle = {
    fontSize: "18px",
    fontWeight: 700,
    color: colors.text.primary
  };
  const totalAmountNumberStyle = {
    fontSize: "14px",
    color: colors.text.muted,
    marginLeft: "8px"
  };
  const totalAmountNoteStyle = {
    fontSize: "11px",
    color: colors.text.muted,
    marginTop: "2px"
  };
  const summaryWrapperStyle = {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-start",
    marginBottom: "20px"
  };
  const summaryTableStyle = {
    width: "300px",
    fontSize: "13px"
  };
  const summaryRowStyle = {
    borderBottom: `1px solid ${colors.border.gray}`
  };
  const summaryLabelStyle = {
    padding: "6px 0",
    color: colors.text.secondary,
    fontWeight: 700
  };
  const summaryValueStyle = {
    padding: "6px 0",
    textAlign: "right",
    fontWeight: 500,
    color: colors.text.primary,
    fontVariantNumeric: "tabular-nums"
  };
  const summaryTotalRowStyle = {
    borderBottom: `2px solid ${theme.accent}`
  };
  const summaryTotalLabelStyle = {
    padding: "8px 0",
    color: theme.accent,
    fontWeight: 900,
    fontSize: "14px"
  };
  const summaryTotalValueStyle = {
    padding: "8px 0",
    textAlign: "right",
    fontWeight: 900,
    color: theme.accent,
    fontSize: "16px",
    fontVariantNumeric: "tabular-nums"
  };
  const notesGridStyle = {
    display: "grid",
    gridTemplateColumns: isPdf ? "1fr 1fr" : "1fr",
    gap: "24px"
  };
  const notesSectionTitleStyle = {
    fontWeight: 700,
    color: colors.text.primary,
    marginBottom: "8px",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "8px"
  };
  const notesTitleBarStyle = {
    width: "4px",
    height: "16px",
    backgroundColor: theme.accent,
    borderRadius: "2px",
    display: "block"
  };
  const notesContentStyle = {
    backgroundColor: colors.background.card,
    border: `1px solid ${colors.border.light}`,
    borderRadius: "8px",
    padding: "12px 16px",
    fontSize: "12px",
    color: colors.text.secondary,
    lineHeight: 1.625,
    whiteSpace: "pre-wrap",
    minHeight: "60px"
  };
  const defaultNotes = "\u2022 \uBCF8 \uACAC\uC801\uC11C\uC758 \uC720\uD6A8\uAE30\uAC04\uC740 \uBC1C\uD589\uC77C\uB85C\uBD80\uD130 30\uC77C\uC785\uB2C8\uB2E4.\n\u2022 \uB0A9\uAE30\uC77C\uC740 \uBC1C\uC8FC \uD6C4 2\uC8FC \uC774\uB0B4\uC785\uB2C8\uB2E4.\n\u2022 \uACB0\uC81C\uC870\uAC74: \uACC4\uC57D \uC2DC 50%, \uB0A9\uD488 \uC644\uB8CC \uD6C4 50% \uD604\uAE08 \uACB0\uC81C \uC870\uAC74\uC785\uB2C8\uB2E4.";
  return /* @__PURE__ */ jsxs10(
    PdfDocument,
    {
      title: `\uACAC\uC801\uC11C - ${quoteNumber}`,
      isPdf,
      fontFamily: theme.fontFamily,
      children: [
        renderHeader(),
        /* @__PURE__ */ jsxs10("div", { style: recipientLineStyle, children: [
          /* @__PURE__ */ jsxs10("div", { style: recipientNameStyle, children: [
            /* @__PURE__ */ jsx11("span", { style: recipientNameTextStyle, children: buyer.companyName }),
            /* @__PURE__ */ jsx11("span", { style: recipientSuffixStyle, children: "\uADC0\uC911" })
          ] }),
          /* @__PURE__ */ jsxs10("div", { style: totalAmountLineStyle, children: [
            /* @__PURE__ */ jsxs10("div", { children: [
              /* @__PURE__ */ jsx11("span", { style: totalAmountLabelStyle, children: "\uD569\uACC4\uAE08\uC561 :" }),
              /* @__PURE__ */ jsxs10("span", { style: totalAmountKoreanStyle, children: [
                "\uC77C\uAE08 ",
                totalAmountKorean,
                "\uC6D0\uC815"
              ] }),
              /* @__PURE__ */ jsxs10("span", { style: totalAmountNumberStyle, children: [
                "(\u20A9",
                totalAmount.toLocaleString(),
                ")"
              ] })
            ] }),
            /* @__PURE__ */ jsx11("div", { style: totalAmountNoteStyle, children: "(\uBD80\uAC00\uAC00\uCE58\uC138 \uD3EC\uD568)" })
          ] })
        ] }),
        /* @__PURE__ */ jsx11(
          QuoteProviderTable,
          {
            provider,
            isBlur,
            accentColor: theme.accent,
            accentLight: theme.accentLight,
            variant: theme.provider
          }
        ),
        /* @__PURE__ */ jsx11(
          QuoteItemsTable,
          {
            items,
            showRowNumber: true,
            minRows: 3,
            accentLight: theme.accentLight,
            accentColor: theme.accent,
            variant: theme.items
          }
        ),
        theme.summary === "bar" ? /* @__PURE__ */ jsxs10("div", { style: { marginBottom: "20px" }, children: [
          /* @__PURE__ */ jsxs10(
            "div",
            {
              style: {
                display: "flex",
                justifyContent: "flex-end",
                gap: "24px",
                fontSize: "13px",
                color: colors.text.secondary,
                marginBottom: "8px",
                fontVariantNumeric: "tabular-nums"
              },
              children: [
                /* @__PURE__ */ jsxs10("span", { children: [
                  "\uACF5\uAE09\uAC00\uC561 ",
                  subtotal.toLocaleString(),
                  "\uC6D0"
                ] }),
                /* @__PURE__ */ jsxs10("span", { children: [
                  "\uC138\uC561(VAT) ",
                  tax.toLocaleString(),
                  "\uC6D0"
                ] })
              ]
            }
          ),
          /* @__PURE__ */ jsxs10(
            "div",
            {
              style: {
                backgroundColor: theme.accent,
                color: "#ffffff",
                padding: "10px 18px",
                borderRadius: "4px",
                display: "flex",
                justifyContent: "space-between",
                fontWeight: 900,
                fontSize: "16px",
                fontVariantNumeric: "tabular-nums"
              },
              children: [
                /* @__PURE__ */ jsx11("span", { children: "\uD569\uACC4\uAE08\uC561" }),
                /* @__PURE__ */ jsxs10("span", { children: [
                  totalAmount.toLocaleString(),
                  "\uC6D0"
                ] })
              ]
            }
          )
        ] }) : /* @__PURE__ */ jsx11("div", { style: summaryWrapperStyle, children: /* @__PURE__ */ jsx11(
          "table",
          {
            style: theme.summary === "box" ? {
              ...summaryTableStyle,
              border: `1px solid ${theme.accent}`,
              borderRadius: "6px",
              padding: "4px 12px"
            } : summaryTableStyle,
            children: /* @__PURE__ */ jsxs10("tbody", { children: [
              /* @__PURE__ */ jsxs10("tr", { style: summaryRowStyle, children: [
                /* @__PURE__ */ jsx11("td", { style: summaryLabelStyle, children: "\uACF5\uAE09\uAC00\uC561" }),
                /* @__PURE__ */ jsxs10("td", { style: summaryValueStyle, children: [
                  subtotal.toLocaleString(),
                  "\uC6D0"
                ] })
              ] }),
              /* @__PURE__ */ jsxs10("tr", { style: summaryRowStyle, children: [
                /* @__PURE__ */ jsx11("td", { style: summaryLabelStyle, children: "\uC138\uC561 (VAT)" }),
                /* @__PURE__ */ jsxs10("td", { style: summaryValueStyle, children: [
                  tax.toLocaleString(),
                  "\uC6D0"
                ] })
              ] }),
              /* @__PURE__ */ jsxs10("tr", { style: summaryTotalRowStyle, children: [
                /* @__PURE__ */ jsx11("td", { style: summaryTotalLabelStyle, children: "\uD569\uACC4\uAE08\uC561" }),
                /* @__PURE__ */ jsxs10("td", { style: summaryTotalValueStyle, children: [
                  totalAmount.toLocaleString(),
                  "\uC6D0"
                ] })
              ] })
            ] })
          }
        ) }),
        /* @__PURE__ */ jsxs10("div", { style: notesGridStyle, children: [
          /* @__PURE__ */ jsxs10("div", { children: [
            /* @__PURE__ */ jsxs10("div", { style: notesSectionTitleStyle, children: [
              /* @__PURE__ */ jsx11("span", { style: notesTitleBarStyle }),
              "\uD2B9\uC774\uC0AC\uD56D"
            ] }),
            /* @__PURE__ */ jsx11("div", { style: notesContentStyle, children: notes ?? defaultNotes })
          ] }),
          isPdf && /* @__PURE__ */ jsxs10("div", { children: [
            /* @__PURE__ */ jsxs10("div", { style: notesSectionTitleStyle, children: [
              /* @__PURE__ */ jsx11("span", { style: notesTitleBarStyle }),
              "\uCCA8\uBD80\uD30C\uC77C"
            ] }),
            /* @__PURE__ */ jsx11("div", { style: notesContentStyle, children: data.attachments && data.attachments.length > 0 ? data.attachments.map((a) => a.fileName).join("\n") : "\uCCA8\uBD80\uD30C\uC77C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4" })
          ] })
        ] })
      ]
    }
  );
}

// src/components/quote/QuoteProviderInfo.tsx
import { Fragment as Fragment4, jsx as jsx12, jsxs as jsxs11 } from "react/jsx-runtime";
function QuoteProviderInfo({
  provider,
  isBlur = false,
  style
}) {
  const contentStyle = {};
  const sealWrapperStyle = {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "12px"
  };
  const sealStyle = {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    backgroundColor: colors.background.muted,
    border: `2px dashed ${colors.border.medium}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "10px",
    color: colors.text.muted,
    overflow: "hidden"
  };
  const sealImageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "contain"
  };
  const managerInfo = provider.managerName ? provider.managerPhone ? `${provider.managerName} (${formatPhoneNumber(provider.managerPhone)})` : provider.managerName : null;
  return /* @__PURE__ */ jsx12(
    MaskedSectionInline,
    {
      isMasked: isBlur,
      scale: "document",
      barCount: 4,
      message: /* @__PURE__ */ jsxs11(Fragment4, { children: [
        "\uACF5\uAE09\uC0AC \uC815\uBCF4\uB294",
        /* @__PURE__ */ jsx12("br", {}),
        "\uACC4\uC57D \uD6C4\uC5D0 \uD655\uC778\uD560 \uC218 \uC788\uC5B4\uC694"
      ] }),
      children: /* @__PURE__ */ jsxs11(PdfSection, { title: "\uACF5\uAE09\uC790", style, children: [
        /* @__PURE__ */ jsxs11("div", { style: contentStyle, children: [
          /* @__PURE__ */ jsx12(PdfInfoRow, { label: "\uC0C1\uD638", value: provider.companyName }),
          /* @__PURE__ */ jsx12(PdfInfoRow, { label: "\uB300\uD45C\uC790", value: provider.representativeName }),
          /* @__PURE__ */ jsx12(
            PdfInfoRow,
            {
              label: "\uC0AC\uC5C5\uC790\uB4F1\uB85D\uBC88\uD638",
              value: formatBusinessNumber(provider.businessNumber)
            }
          ),
          /* @__PURE__ */ jsx12(PdfInfoRow, { label: "\uC8FC\uC18C", value: provider.address }),
          provider.businessType && /* @__PURE__ */ jsx12(PdfInfoRow, { label: "\uC5C5\uD0DC/\uC885\uBAA9", value: provider.businessType }),
          provider.phoneNumber && /* @__PURE__ */ jsx12(
            PdfInfoRow,
            {
              label: "\uC5F0\uB77D\uCC98",
              value: formatPhoneNumber(provider.phoneNumber)
            }
          ),
          managerInfo && /* @__PURE__ */ jsx12(PdfInfoRow, { label: "\uB2F4\uB2F9\uC790", value: managerInfo }),
          provider.email && /* @__PURE__ */ jsx12(PdfInfoRow, { label: "\uC774\uBA54\uC77C", value: provider.email })
        ] }),
        /* @__PURE__ */ jsx12("div", { style: sealWrapperStyle, children: /* @__PURE__ */ jsx12("div", { style: sealStyle, children: /* @__PURE__ */ jsx12(
          SealImage,
          {
            url: provider.companySealUrl,
            style: sealImageStyle,
            fallback: "(\uC778)"
          }
        ) }) })
      ] })
    }
  );
}

// src/components/quote/QuoteBuyerInfo.tsx
import { jsx as jsx13, jsxs as jsxs12 } from "react/jsx-runtime";
function QuoteBuyerInfo({
  buyer,
  style
}) {
  return /* @__PURE__ */ jsxs12(PdfSection, { title: "\uC218\uC2E0", style, children: [
    /* @__PURE__ */ jsx13(PdfInfoRow, { label: "\uD68C\uC0AC\uBA85", value: buyer.companyName }),
    buyer.representativeName && /* @__PURE__ */ jsx13(PdfInfoRow, { label: "\uB300\uD45C\uC790", value: buyer.representativeName }),
    buyer.department && /* @__PURE__ */ jsx13(PdfInfoRow, { label: "\uBD80\uC11C", value: buyer.department }),
    buyer.contactName && /* @__PURE__ */ jsx13(PdfInfoRow, { label: "\uB2F4\uB2F9\uC790", value: buyer.contactName }),
    buyer.phoneNumber && /* @__PURE__ */ jsx13(
      PdfInfoRow,
      {
        label: "\uC5F0\uB77D\uCC98",
        value: formatPhoneNumber(buyer.phoneNumber)
      }
    ),
    buyer.email && /* @__PURE__ */ jsx13(PdfInfoRow, { label: "\uC774\uBA54\uC77C", value: buyer.email }),
    buyer.address && /* @__PURE__ */ jsx13(PdfInfoRow, { label: "\uC8FC\uC18C", value: buyer.address })
  ] });
}

// src/components/contract/ContractHeader.tsx
import { jsx as jsx14, jsxs as jsxs13 } from "react/jsx-runtime";
function ContractHeader({
  contractDate
}) {
  const headerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginBottom: "32px",
    borderBottom: `1px solid ${colors.border.gray}`,
    paddingBottom: "24px"
  };
  const titleStyle = {
    fontSize: "48px",
    fontWeight: 900,
    letterSpacing: "0.2em",
    color: colors.primary,
    lineHeight: 1.25,
    margin: 0
  };
  const dateStyle = {
    fontSize: "14px",
    color: colors.text.muted,
    textAlign: "right"
  };
  return /* @__PURE__ */ jsxs13("header", { style: headerStyle, children: [
    /* @__PURE__ */ jsx14("h1", { style: titleStyle, children: "\uACC4 \uC57D \uC11C" }),
    /* @__PURE__ */ jsxs13("div", { style: dateStyle, children: [
      "\uACC4\uC57D\uC77C: ",
      contractDate
    ] })
  ] });
}

// src/components/contract/ContractRecipientAmount.tsx
import { jsx as jsx15, jsxs as jsxs14 } from "react/jsx-runtime";
function ContractRecipientAmount({
  buyer,
  totalAmount
}) {
  const totalAmountKorean = convertNumberToKorean(totalAmount);
  const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginBottom: "32px",
    gap: "24px"
  };
  const recipientStyle = {
    borderBottom: `2px solid ${colors.text.primary}`,
    paddingBottom: "4px",
    paddingRight: "24px",
    display: "inline-block",
    minWidth: "140px"
  };
  const nameStyle = {
    fontSize: "24px",
    fontWeight: 700,
    color: colors.text.primary,
    marginRight: "8px"
  };
  const suffixStyle = {
    fontSize: "20px",
    fontWeight: 400,
    color: colors.text.secondary
  };
  const amountContainerStyle = {
    textAlign: "right"
  };
  const labelStyle = {
    color: colors.text.secondary,
    fontSize: "16px",
    fontWeight: 700,
    marginRight: "16px"
  };
  const koreanStyle = {
    fontSize: "24px",
    fontWeight: 700,
    color: colors.text.primary
  };
  const numberStyle = {
    fontSize: "18px",
    color: colors.text.muted,
    marginLeft: "8px"
  };
  const noteStyle = {
    fontSize: "12px",
    color: colors.text.muted,
    marginTop: "4px"
  };
  const detailStyle = {
    fontSize: "12px",
    color: colors.text.secondary,
    marginTop: "6px",
    lineHeight: 1.6
  };
  const addressStyle = {
    fontSize: "12px",
    color: colors.text.muted,
    marginTop: "8px",
    display: "block"
  };
  return /* @__PURE__ */ jsxs14("div", { style: containerStyle, children: [
    /* @__PURE__ */ jsxs14("div", { children: [
      /* @__PURE__ */ jsx15("div", { style: recipientStyle, children: /* @__PURE__ */ jsxs14("div", { children: [
        /* @__PURE__ */ jsx15("span", { style: nameStyle, children: buyer.companyName }),
        /* @__PURE__ */ jsx15("span", { style: suffixStyle, children: "\uADC0\uC911" })
      ] }) }),
      /* @__PURE__ */ jsxs14("div", { style: detailStyle, children: [
        buyer.representativeName && /* @__PURE__ */ jsxs14("div", { children: [
          "\uB300\uD45C\uC790 : ",
          buyer.representativeName
        ] }),
        buyer.businessNumber && /* @__PURE__ */ jsxs14("div", { children: [
          "\uC0AC\uC5C5\uC790\uB4F1\uB85D\uBC88\uD638 : ",
          buyer.businessNumber
        ] }),
        buyer.phoneNumber && /* @__PURE__ */ jsxs14("div", { children: [
          "\uC804\uD654\uBC88\uD638 : ",
          buyer.phoneNumber
        ] }),
        buyer.address && /* @__PURE__ */ jsxs14("div", { children: [
          "\uC8FC\uC18C : ",
          buyer.address
        ] })
      ] }),
      buyer.deliveryAddress && /* @__PURE__ */ jsxs14("span", { style: addressStyle, children: [
        "\uBC30\uC1A1\uC9C0: ",
        buyer.deliveryAddress
      ] })
    ] }),
    /* @__PURE__ */ jsxs14("div", { style: amountContainerStyle, children: [
      /* @__PURE__ */ jsxs14("div", { children: [
        /* @__PURE__ */ jsx15("span", { style: labelStyle, children: "\uD569\uACC4\uAE08\uC561 :" }),
        /* @__PURE__ */ jsxs14("span", { style: koreanStyle, children: [
          "\uC77C\uAE08 ",
          totalAmountKorean,
          "\uC6D0\uC815"
        ] }),
        /* @__PURE__ */ jsxs14("span", { style: numberStyle, children: [
          "(\u20A9",
          totalAmount.toLocaleString(),
          ")"
        ] })
      ] }),
      /* @__PURE__ */ jsx15("div", { style: noteStyle, children: "(\uBD80\uAC00\uAC00\uCE58\uC138 \uD3EC\uD568)" })
    ] })
  ] });
}

// src/components/contract/ContractProviderTable.tsx
import { Fragment as Fragment5, jsx as jsx16, jsxs as jsxs15 } from "react/jsx-runtime";
function ContractProviderTable({
  provider,
  isBlur = false
}) {
  const containerStyle = {
    marginBottom: "24px",
    position: "relative"
  };
  const tableWrapperStyle = {
    border: `1px solid ${colors.border.table}`,
    borderRadius: "8px",
    overflow: "hidden",
    display: "flex"
  };
  const sidebarStyle = {
    width: "8px",
    backgroundColor: colors.primary,
    flexShrink: 0
  };
  const tableStyle = {
    width: "100%",
    fontSize: "13px",
    borderCollapse: "collapse"
  };
  const labelStyle = {
    width: "100px",
    padding: "10px 12px",
    backgroundColor: colors.background.highlight,
    color: colors.text.secondary,
    fontWeight: 600,
    borderBottom: `1px solid ${colors.border.inner}`,
    borderRight: `1px solid ${colors.border.inner}`
  };
  const valueStyle = {
    padding: "10px 12px",
    color: colors.text.primary,
    borderBottom: `1px solid ${colors.border.inner}`
  };
  const sealContainerStyle = {
    position: "absolute",
    right: "20px",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 10
  };
  const sealStyle = {
    width: "80px",
    height: "80px",
    objectFit: "contain"
  };
  return /* @__PURE__ */ jsx16(
    MaskedSectionInline,
    {
      isMasked: isBlur,
      scale: "document",
      barCount: 4,
      message: /* @__PURE__ */ jsxs15(Fragment5, { children: [
        "\uACF5\uAE09\uC0AC \uC815\uBCF4\uB294",
        /* @__PURE__ */ jsx16("br", {}),
        "\uACC4\uC57D \uD6C4\uC5D0 \uD655\uC778\uD560 \uC218 \uC788\uC5B4\uC694"
      ] }),
      children: /* @__PURE__ */ jsxs15("div", { style: containerStyle, children: [
        /* @__PURE__ */ jsxs15("div", { style: tableWrapperStyle, children: [
          /* @__PURE__ */ jsx16("div", { style: sidebarStyle }),
          /* @__PURE__ */ jsx16("table", { style: tableStyle, children: /* @__PURE__ */ jsxs15("tbody", { children: [
            /* @__PURE__ */ jsxs15("tr", { children: [
              /* @__PURE__ */ jsx16("td", { style: labelStyle, children: "\uC0C1\uD638" }),
              /* @__PURE__ */ jsx16("td", { style: valueStyle, children: provider.companyName }),
              /* @__PURE__ */ jsx16("td", { style: labelStyle, children: "\uB300\uD45C\uC790" }),
              /* @__PURE__ */ jsx16("td", { style: valueStyle, children: provider.representativeName })
            ] }),
            /* @__PURE__ */ jsxs15("tr", { children: [
              /* @__PURE__ */ jsx16("td", { style: labelStyle, children: "\uC0AC\uC5C5\uC790\uBC88\uD638" }),
              /* @__PURE__ */ jsx16("td", { style: valueStyle, children: formatBusinessNumber(provider.businessNumber) }),
              /* @__PURE__ */ jsx16("td", { style: labelStyle, children: "\uC5C5\uD0DC/\uC885\uBAA9" }),
              /* @__PURE__ */ jsxs15("td", { style: valueStyle, children: [
                provider.businessType ?? "-",
                " /",
                " ",
                provider.businessCategory ?? "-"
              ] })
            ] }),
            /* @__PURE__ */ jsxs15("tr", { children: [
              /* @__PURE__ */ jsx16("td", { style: labelStyle, children: "\uC8FC\uC18C" }),
              /* @__PURE__ */ jsx16(
                "td",
                {
                  style: {
                    ...valueStyle,
                    borderRight: `1px solid ${colors.border.inner}`
                  },
                  colSpan: 3,
                  children: provider.address
                }
              )
            ] }),
            /* @__PURE__ */ jsxs15("tr", { children: [
              /* @__PURE__ */ jsx16("td", { style: { ...labelStyle, borderBottom: "none" }, children: "\uC5F0\uB77D\uCC98" }),
              /* @__PURE__ */ jsx16("td", { style: { ...valueStyle, borderBottom: "none" }, children: provider.phoneNumber ? formatPhoneNumber(provider.phoneNumber) : "-" }),
              /* @__PURE__ */ jsx16("td", { style: { ...labelStyle, borderBottom: "none" }, children: "\uC774\uBA54\uC77C" }),
              /* @__PURE__ */ jsx16("td", { style: { ...valueStyle, borderBottom: "none" }, children: provider.email ?? "-" })
            ] })
          ] }) })
        ] }),
        provider.companySealUrl && /* @__PURE__ */ jsx16("div", { style: sealContainerStyle, children: /* @__PURE__ */ jsx16(SealImage, { url: provider.companySealUrl, style: sealStyle }) })
      ] })
    }
  );
}

// src/components/contract/ContractItemsTable.tsx
import { Fragment as Fragment6, jsx as jsx17, jsxs as jsxs16 } from "react/jsx-runtime";
function ContractItemsTable({
  items,
  categoryType = "product",
  minRows = 5
}) {
  const itemLabel = categoryType === "project" ? "\uD504\uB85C\uC81D\uD2B8\uBA85" : "\uD488\uBA85 \uBC0F \uADDC\uACA9";
  const tableWrapperStyle = {
    marginBottom: "24px",
    border: `1px solid ${colors.border.table}`,
    borderRadius: "8px",
    overflow: "hidden"
  };
  const tableStyle = {
    width: "100%",
    fontSize: "12px",
    borderCollapse: "collapse",
    tableLayout: "fixed"
  };
  const thStyle = {
    backgroundColor: colors.background.tableHeader,
    padding: "10px 6px",
    wordBreak: "keep-all",
    textAlign: "center",
    fontWeight: 600,
    color: colors.text.secondary,
    borderBottom: `2px solid ${colors.border.table}`,
    borderRight: `1px solid ${colors.border.inner}`
  };
  const thLastStyle = {
    ...thStyle,
    borderRight: "none"
  };
  const tdStyle = {
    padding: "8px",
    textAlign: "center",
    borderBottom: `1px solid ${colors.border.inner}`,
    borderRight: `1px solid ${colors.border.inner}`,
    color: colors.text.primary,
    height: "36px"
  };
  const tdLastStyle = {
    ...tdStyle,
    borderRight: "none"
  };
  const tdNameStyle = {
    ...tdStyle,
    textAlign: "left",
    fontWeight: 500,
    wordBreak: "keep-all",
    overflowWrap: "anywhere"
  };
  const tdAmountStyle = {
    ...tdStyle,
    textAlign: "right",
    fontVariantNumeric: "tabular-nums",
    borderRight: "none"
  };
  const emptyRows = Math.max(0, minRows - items.length);
  const emptyRowsArray = Array.from({ length: emptyRows }, (_, i) => i);
  return /* @__PURE__ */ jsx17("div", { style: tableWrapperStyle, children: /* @__PURE__ */ jsxs16("table", { style: tableStyle, children: [
    /* @__PURE__ */ jsx17("thead", { children: /* @__PURE__ */ jsxs16("tr", { children: [
      /* @__PURE__ */ jsx17("th", { style: { ...thStyle, width: "32px" }, children: "No" }),
      /* @__PURE__ */ jsx17("th", { style: { ...thStyle, textAlign: "left" }, children: itemLabel }),
      categoryType === "product" && /* @__PURE__ */ jsxs16(Fragment6, { children: [
        /* @__PURE__ */ jsx17("th", { style: { ...thStyle, width: "64px" }, children: "\uADDC\uACA91" }),
        /* @__PURE__ */ jsx17("th", { style: { ...thStyle, width: "64px" }, children: "\uADDC\uACA92" }),
        /* @__PURE__ */ jsx17("th", { style: { ...thStyle, width: "64px" }, children: "\uADDC\uACA93" })
      ] }),
      /* @__PURE__ */ jsx17("th", { style: { ...thStyle, width: "56px" }, children: "\uC218\uB7C9" }),
      /* @__PURE__ */ jsxs16("th", { style: { ...thStyle, width: "84px" }, children: [
        "\uB2E8\uAC00",
        /* @__PURE__ */ jsx17("br", {}),
        "(\uACF5\uAE09\uAC00\uC561)"
      ] }),
      /* @__PURE__ */ jsx17("th", { style: { ...thLastStyle, width: "88px" }, children: "\uAE08\uC561" })
    ] }) }),
    /* @__PURE__ */ jsxs16("tbody", { children: [
      items.map((item, index) => /* @__PURE__ */ jsxs16("tr", { children: [
        /* @__PURE__ */ jsx17("td", { style: tdStyle, children: index + 1 }),
        /* @__PURE__ */ jsxs16("td", { style: tdNameStyle, children: [
          item.name,
          item.description && /* @__PURE__ */ jsx17(
            "div",
            {
              style: {
                fontSize: "11px",
                color: colors.text.muted,
                marginTop: "2px"
              },
              children: item.description
            }
          )
        ] }),
        categoryType === "product" && /* @__PURE__ */ jsxs16(Fragment6, { children: [
          /* @__PURE__ */ jsx17("td", { style: tdStyle, children: item.spec1 ?? "-" }),
          /* @__PURE__ */ jsx17("td", { style: tdStyle, children: item.spec2 ?? "-" }),
          /* @__PURE__ */ jsx17("td", { style: tdStyle, children: item.spec3 ?? "-" })
        ] }),
        /* @__PURE__ */ jsxs16("td", { style: tdStyle, children: [
          item.quantity,
          item.unit && /* @__PURE__ */ jsx17("span", { style: { marginLeft: "2px" }, children: item.unit })
        ] }),
        /* @__PURE__ */ jsx17(
          "td",
          {
            style: {
              ...tdStyle,
              textAlign: "right",
              fontVariantNumeric: "tabular-nums"
            },
            children: formatCurrency(item.unitPrice)
          }
        ),
        /* @__PURE__ */ jsx17("td", { style: tdAmountStyle, children: formatCurrency(item.amount) })
      ] }, index)),
      emptyRowsArray.map((_, index) => /* @__PURE__ */ jsxs16("tr", { children: [
        /* @__PURE__ */ jsx17(
          "td",
          {
            style: {
              ...tdStyle,
              borderBottom: index === emptyRows - 1 ? "none" : void 0
            },
            children: "\xA0"
          }
        ),
        /* @__PURE__ */ jsx17(
          "td",
          {
            style: {
              ...tdNameStyle,
              borderBottom: index === emptyRows - 1 ? "none" : void 0
            },
            children: "\xA0"
          }
        ),
        categoryType === "product" && /* @__PURE__ */ jsxs16(Fragment6, { children: [
          /* @__PURE__ */ jsx17(
            "td",
            {
              style: {
                ...tdStyle,
                borderBottom: index === emptyRows - 1 ? "none" : void 0
              },
              children: "\xA0"
            }
          ),
          /* @__PURE__ */ jsx17(
            "td",
            {
              style: {
                ...tdStyle,
                borderBottom: index === emptyRows - 1 ? "none" : void 0
              },
              children: "\xA0"
            }
          ),
          /* @__PURE__ */ jsx17(
            "td",
            {
              style: {
                ...tdStyle,
                borderBottom: index === emptyRows - 1 ? "none" : void 0
              },
              children: "\xA0"
            }
          )
        ] }),
        /* @__PURE__ */ jsx17(
          "td",
          {
            style: {
              ...tdStyle,
              borderBottom: index === emptyRows - 1 ? "none" : void 0
            },
            children: "\xA0"
          }
        ),
        /* @__PURE__ */ jsx17(
          "td",
          {
            style: {
              ...tdStyle,
              borderBottom: index === emptyRows - 1 ? "none" : void 0
            },
            children: "\xA0"
          }
        ),
        /* @__PURE__ */ jsx17(
          "td",
          {
            style: {
              ...tdLastStyle,
              borderBottom: index === emptyRows - 1 ? "none" : void 0
            },
            children: "\xA0"
          }
        )
      ] }, `empty-${String(index)}`))
    ] })
  ] }) });
}

// src/components/contract/ContractSummary.tsx
import { jsx as jsx18, jsxs as jsxs17 } from "react/jsx-runtime";
function ContractSummary({
  subtotal,
  tax,
  totalAmount
}) {
  const wrapperStyle = {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-start",
    marginBottom: "32px"
  };
  const tableStyle = {
    width: "300px",
    fontSize: "14px"
  };
  const rowStyle = {
    borderBottom: `1px solid ${colors.border.gray}`
  };
  const labelStyle = {
    padding: "8px 0",
    color: colors.text.secondary,
    fontWeight: 700
  };
  const valueStyle = {
    padding: "8px 0",
    textAlign: "right",
    fontWeight: 500,
    color: colors.text.primary,
    fontVariantNumeric: "tabular-nums"
  };
  const totalRowStyle = {
    borderBottom: `2px solid ${colors.primary}`
  };
  const totalLabelStyle = {
    padding: "12px 0",
    color: colors.primary,
    fontWeight: 900,
    fontSize: "16px"
  };
  const totalValueStyle = {
    padding: "12px 0",
    textAlign: "right",
    fontWeight: 900,
    color: colors.primary,
    fontSize: "18px",
    fontVariantNumeric: "tabular-nums"
  };
  return /* @__PURE__ */ jsx18("div", { style: wrapperStyle, children: /* @__PURE__ */ jsx18("table", { style: tableStyle, children: /* @__PURE__ */ jsxs17("tbody", { children: [
    /* @__PURE__ */ jsxs17("tr", { style: rowStyle, children: [
      /* @__PURE__ */ jsx18("td", { style: labelStyle, children: "\uACF5\uAE09\uAC00\uC561" }),
      /* @__PURE__ */ jsxs17("td", { style: valueStyle, children: [
        formatCurrency(subtotal),
        "\uC6D0"
      ] })
    ] }),
    /* @__PURE__ */ jsxs17("tr", { style: rowStyle, children: [
      /* @__PURE__ */ jsx18("td", { style: labelStyle, children: "\uC138\uC561 (VAT)" }),
      /* @__PURE__ */ jsxs17("td", { style: valueStyle, children: [
        formatCurrency(tax),
        "\uC6D0"
      ] })
    ] }),
    /* @__PURE__ */ jsxs17("tr", { style: totalRowStyle, children: [
      /* @__PURE__ */ jsx18("td", { style: totalLabelStyle, children: "\uD569\uACC4\uAE08\uC561" }),
      /* @__PURE__ */ jsxs17("td", { style: totalValueStyle, children: [
        formatCurrency(totalAmount),
        "\uC6D0"
      ] })
    ] })
  ] }) }) });
}

// src/components/contract/ContractNotesGrid.tsx
import { jsx as jsx19, jsxs as jsxs18 } from "react/jsx-runtime";
function ContractNotesGrid({
  notes,
  attachments,
  isPdf = false
}) {
  const gridStyle = {
    display: "grid",
    gridTemplateColumns: isPdf ? "1fr 1fr" : "1fr",
    gap: "24px"
  };
  const sectionTitleStyle = {
    fontWeight: 700,
    color: colors.text.primary,
    marginBottom: "8px",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "8px"
  };
  const titleBarStyle = {
    width: "4px",
    height: "16px",
    backgroundColor: colors.primary,
    borderRadius: "2px"
  };
  const contentStyle = {
    backgroundColor: colors.background.card,
    border: `1px solid ${colors.border.light}`,
    borderRadius: "8px",
    padding: "16px",
    fontSize: "12px",
    color: colors.text.secondary,
    lineHeight: 1.625,
    whiteSpace: "pre-wrap",
    minHeight: "100px"
  };
  const hasNotes = typeof notes === "string" && notes.trim() !== "";
  const sectionStyle = {
    breakInside: "avoid",
    pageBreakInside: "avoid"
  };
  return /* @__PURE__ */ jsxs18("div", { style: { ...gridStyle, ...sectionStyle }, children: [
    /* @__PURE__ */ jsxs18("div", { style: sectionStyle, children: [
      /* @__PURE__ */ jsxs18("div", { style: sectionTitleStyle, children: [
        /* @__PURE__ */ jsx19("span", { style: titleBarStyle }),
        "\uD2B9\uC774\uC0AC\uD56D"
      ] }),
      /* @__PURE__ */ jsx19("div", { style: contentStyle, children: hasNotes ? notes : "\uD2B9\uC774\uC0AC\uD56D\uC774 \uC5C6\uC2B5\uB2C8\uB2E4" })
    ] }),
    isPdf && /* @__PURE__ */ jsxs18("div", { style: sectionStyle, children: [
      /* @__PURE__ */ jsxs18("div", { style: sectionTitleStyle, children: [
        /* @__PURE__ */ jsx19("span", { style: titleBarStyle }),
        "\uCCA8\uBD80\uD30C\uC77C"
      ] }),
      /* @__PURE__ */ jsx19("div", { style: contentStyle, children: attachments && attachments.length > 0 ? attachments.map((a) => a.fileName).join("\n") : "\uCCA8\uBD80\uD30C\uC77C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4" })
    ] })
  ] });
}

// src/components/contract/ContractPdfDocument.tsx
import { jsx as jsx20, jsxs as jsxs19 } from "react/jsx-runtime";
function ContractPdfDocument({
  data,
  isPdf = false,
  isBlur = false
}) {
  const {
    contractNumber,
    contractDate,
    categoryType,
    supplier,
    buyer,
    items,
    subtotal,
    tax,
    totalAmount,
    notes,
    attachments
  } = data;
  return /* @__PURE__ */ jsxs19(PdfDocument, { title: `\uACC4\uC57D\uC11C - ${contractNumber}`, isPdf, children: [
    /* @__PURE__ */ jsx20(ContractHeader, { contractDate }),
    /* @__PURE__ */ jsx20(ContractRecipientAmount, { buyer, totalAmount }),
    /* @__PURE__ */ jsx20(ContractProviderTable, { provider: supplier, isBlur }),
    /* @__PURE__ */ jsx20(
      ContractItemsTable,
      {
        items,
        categoryType,
        minRows: 5
      }
    ),
    /* @__PURE__ */ jsx20(
      ContractSummary,
      {
        subtotal,
        tax,
        totalAmount
      }
    ),
    /* @__PURE__ */ jsx20(
      ContractNotesGrid,
      {
        notes,
        attachments,
        isPdf
      }
    )
  ] });
}

// src/components/contract/CancellationConfirmationPdfDocument.tsx
import { jsx as jsx21, jsxs as jsxs20 } from "react/jsx-runtime";
function CancellationConfirmationPdfDocument({
  data,
  isPdf = false
}) {
  const {
    contractNumber,
    projectName,
    paymentMethod,
    cancelledAt,
    tid,
    totalAmount,
    supplier,
    buyer,
    reason
  } = data;
  const isCash = paymentMethod === "CASH";
  const formatCurrency2 = (amount) => {
    return new Intl.NumberFormat("ko-KR").format(amount);
  };
  return /* @__PURE__ */ jsxs20(PdfDocument, { title: `\uACC4\uC57D \uCDE8\uC18C \uD655\uC778\uC11C - ${contractNumber}`, isPdf, children: [
    /* @__PURE__ */ jsx21(
      "div",
      {
        style: {
          position: "absolute",
          top: "40px",
          right: "40px",
          border: `3px solid ${colors.status.error}`,
          borderRadius: "8px",
          padding: "8px 20px",
          color: colors.status.error,
          fontSize: "24px",
          fontWeight: "bold",
          opacity: 0.7,
          transform: "rotate(15deg)"
        },
        children: "\uCDE8\uC18C \uC644\uB8CC"
      }
    ),
    /* @__PURE__ */ jsx21(
      "div",
      {
        style: { textAlign: "center", marginBottom: "40px", marginTop: "20px" },
        children: /* @__PURE__ */ jsx21(
          "h1",
          {
            style: {
              fontSize: "32px",
              fontWeight: "bold",
              color: colors.text.primary,
              letterSpacing: "4px"
            },
            children: "\uACC4\uC57D \uCDE8\uC18C \uD655\uC778\uC11C"
          }
        )
      }
    ),
    /* @__PURE__ */ jsxs20(
      "div",
      {
        style: {
          backgroundColor: colors.background.highlight,
          padding: "30px",
          borderRadius: "12px",
          textAlign: "center",
          marginBottom: "40px",
          border: `1px solid ${colors.border.light}`
        },
        children: [
          /* @__PURE__ */ jsx21(
            "p",
            {
              style: {
                fontSize: "14px",
                color: colors.text.secondary,
                marginBottom: "8px"
              },
              children: "\uC804\uC561 \uD658\uBD88 \uC644\uB8CC"
            }
          ),
          /* @__PURE__ */ jsxs20(
            "div",
            {
              style: {
                fontSize: "36px",
                fontWeight: "900",
                color: colors.text.primary
              },
              children: [
                "-",
                formatCurrency2(totalAmount),
                /* @__PURE__ */ jsx21(
                  "span",
                  {
                    style: { fontSize: "20px", fontWeight: "bold", marginLeft: "4px" },
                    children: "\uC6D0"
                  }
                )
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxs20("div", { style: { marginBottom: "40px" }, children: [
      /* @__PURE__ */ jsx21("h3", { style: baseStyles.sectionTitle, children: "\uC0C1\uC138 \uC815\uBCF4" }),
      /* @__PURE__ */ jsx21("table", { style: baseStyles.table, children: /* @__PURE__ */ jsxs20("tbody", { children: [
        /* @__PURE__ */ jsxs20("tr", { children: [
          /* @__PURE__ */ jsx21(
            "td",
            {
              style: {
                ...baseStyles.tableCell,
                width: "150px",
                color: colors.text.secondary
              },
              children: "\uACC4\uC57D \uBC88\uD638"
            }
          ),
          /* @__PURE__ */ jsx21("td", { style: baseStyles.tableCell, children: contractNumber })
        ] }),
        /* @__PURE__ */ jsxs20("tr", { children: [
          /* @__PURE__ */ jsx21(
            "td",
            {
              style: {
                ...baseStyles.tableCell,
                color: colors.text.secondary
              },
              children: "\uD504\uB85C\uC81D\uD2B8\uBA85"
            }
          ),
          /* @__PURE__ */ jsx21("td", { style: { ...baseStyles.tableCell, fontWeight: "bold" }, children: projectName })
        ] }),
        /* @__PURE__ */ jsxs20("tr", { children: [
          /* @__PURE__ */ jsx21(
            "td",
            {
              style: {
                ...baseStyles.tableCell,
                color: colors.text.secondary
              },
              children: "\uACB0\uC81C \uC218\uB2E8"
            }
          ),
          /* @__PURE__ */ jsx21("td", { style: baseStyles.tableCell, children: isCash ? "\uD604\uAE08 \uACB0\uC81C (\uACC4\uC88C\uC774\uCCB4)" : "\uCE74\uB4DC \uACB0\uC81C" })
        ] }),
        /* @__PURE__ */ jsxs20("tr", { children: [
          /* @__PURE__ */ jsx21(
            "td",
            {
              style: {
                ...baseStyles.tableCell,
                color: colors.text.secondary
              },
              children: "\uCDE8\uC18C \uC77C\uC2DC"
            }
          ),
          /* @__PURE__ */ jsx21("td", { style: baseStyles.tableCell, children: cancelledAt })
        ] }),
        tid && /* @__PURE__ */ jsxs20("tr", { children: [
          /* @__PURE__ */ jsx21(
            "td",
            {
              style: {
                ...baseStyles.tableCell,
                color: colors.text.secondary
              },
              children: "\uAC70\uB798 \uBC88\uD638"
            }
          ),
          /* @__PURE__ */ jsx21(
            "td",
            {
              style: {
                ...baseStyles.tableCell,
                fontFamily: "monospace",
                fontSize: "13px"
              },
              children: tid
            }
          )
        ] }),
        reason && /* @__PURE__ */ jsxs20("tr", { children: [
          /* @__PURE__ */ jsx21(
            "td",
            {
              style: {
                ...baseStyles.tableCell,
                color: colors.text.secondary
              },
              children: "\uCDE8\uC18C \uC0AC\uC720"
            }
          ),
          /* @__PURE__ */ jsx21("td", { style: baseStyles.tableCell, children: reason })
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ jsxs20(
      "div",
      {
        style: {
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "40px",
          marginBottom: "60px"
        },
        children: [
          /* @__PURE__ */ jsxs20("div", { children: [
            /* @__PURE__ */ jsx21("h3", { style: baseStyles.sectionTitle, children: "\uD310\uB9E4\uC790" }),
            /* @__PURE__ */ jsx21(
              "p",
              {
                style: {
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: colors.text.primary
                },
                children: supplier.name
              }
            )
          ] }),
          /* @__PURE__ */ jsxs20("div", { style: { textAlign: "right" }, children: [
            /* @__PURE__ */ jsx21("h3", { style: { ...baseStyles.sectionTitle, textAlign: "right" }, children: "\uAD6C\uB9E4\uC790" }),
            /* @__PURE__ */ jsx21(
              "p",
              {
                style: {
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: colors.text.primary
                },
                children: buyer.name
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxs20(
      "div",
      {
        style: {
          marginTop: "100px",
          paddingTop: "30px",
          borderTop: `1px solid ${colors.border.light}`,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ jsxs20(
            "p",
            {
              style: {
                fontSize: "12px",
                color: colors.text.muted,
                lineHeight: "1.8"
              },
              children: [
                "\uBCF8 \uD655\uC778\uC11C\uB294 \uC704 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uB300\uD55C \uACC4\uC57D \uBC0F \uACB0\uC81C\uAC00 \uC815\uC0C1\uC801\uC73C\uB85C \uCDE8\uC18C\uB418\uC5C8\uC74C\uC744 \uC99D\uBE59\uD569\uB2C8\uB2E4.",
                /* @__PURE__ */ jsx21("br", {}),
                "\uD658\uBD88 \uAD00\uB828 \uBB38\uC758\uB294 \uACE0\uAC1D\uC13C\uD130 \uB610\uB294 \uD310\uB9E4\uC790\uB97C \uD1B5\uD574 \uD655\uC778\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
              ]
            }
          ),
          /* @__PURE__ */ jsx21(
            "p",
            {
              style: {
                fontSize: "14px",
                fontWeight: "bold",
                color: colors.text.secondary,
                marginTop: "20px"
              },
              children: "SEMO (\uC138\uBAA8) - \uC2A4\uB9C8\uD2B8 \uC774\uCEE4\uBA38\uC2A4 \uC544\uC6C3\uC18C\uC2F1 \uD50C\uB7AB\uD3FC"
            }
          )
        ]
      }
    )
  ] });
}

// src/utils/renderToHtml.ts
import { renderToString } from "react-dom/server";
function renderToHtml(element) {
  const html = renderToString(element);
  if (html.startsWith("<html")) {
    return `<!DOCTYPE html>${html}`;
  }
  return `<!DOCTYPE html>
<html lang="ko">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>SEMO Document</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body {
      font-family: 'Pretendard Variable', 'Pretendard', 'Malgun Gothic', 'Apple SD Gothic Neo', 'Noto Sans KR', sans-serif;
      font-size: 14px;
      line-height: 1.5;
      color: #222;
      background: #fff;
    }
    @page { size: A4; margin: 12mm; }
  </style>
</head>
<body>
  ${html}
</body>
</html>`;
}
function renderToHtmlFragment(element) {
  return renderToString(element);
}

// src/utils/mapQuoteData.ts
var defaultOptions = {
  quoteNumberFormat: (versionNumber, messageId) => `Q-${String(versionNumber)}-${messageId.slice(-6).toUpperCase()}`,
  dateFormatter: formatDateKorean
};
function mapProvider(supplier) {
  return {
    companyName: supplier?.companyName ?? "\uC5C5\uCCB4\uBA85 \uBBF8\uC785\uB825",
    representativeName: supplier?.ceoName ?? "-",
    businessNumber: supplier?.businessNumber ?? "-",
    address: supplier?.addressFull ?? "-",
    phoneNumber: supplier?.companyPhone,
    businessType: supplier?.businessType,
    managerName: supplier?.managerName,
    managerPhone: supplier?.managerPhone,
    companySealUrl: supplier?.companySealUrl
  };
}
function mapBuyer(buyer) {
  return {
    // 비었을 때 «발주기관» — 견적서 PDF(서버)와 같은 대체 이름(GS A5-07, 종전 «수신자 미입력»).
    companyName: buyer?.name ?? "\uBC1C\uC8FC\uAE30\uAD00",
    contactName: buyer?.name,
    phoneNumber: buyer?.phone
  };
}
function mapItems(items) {
  if (!items || items.length === 0) {
    return [];
  }
  return items.map((item) => ({
    name: item.name ?? "\uD488\uBA85 \uBBF8\uC785\uB825",
    specification: item.spec ?? item.notes,
    quantity: item.quantity ?? 0,
    unit: item.unit ?? "\uAC1C",
    unitPrice: item.unitPrice ?? (item.quantity ? (item.amount ?? 0) / item.quantity : 0),
    amount: item.amount ?? (item.quantity ?? 0) * (item.unitPrice ?? 0)
  }));
}
function mapAttachments(attachments) {
  if (!attachments || attachments.length === 0) {
    return [];
  }
  return attachments.map((att) => ({
    fileName: att.fileName ?? "file",
    url: att.url ?? "",
    fileSize: att.fileSize,
    mimeType: att.contentType
  }));
}
function mapQuoteMessageToQuotePdfData(message, options) {
  const opts = { ...defaultOptions, ...options };
  const quoteData = message.quoteData ?? {};
  const totalAmount = quoteData.totalAmount ?? 0;
  const { subtotal, tax } = calculateFromTotal(totalAmount);
  return {
    // 기본 정보
    quoteNumber: opts.quoteNumberFormat(
      quoteData.versionNumber ?? 1,
      message.id
    ),
    quoteDate: opts.dateFormatter(message.createdAt),
    versionNumber: quoteData.versionNumber,
    // 공급자/수신자
    provider: mapProvider(quoteData.supplier),
    buyer: mapBuyer(quoteData.buyer),
    // 품목
    items: mapItems(quoteData.items),
    // 금액
    subtotal,
    tax,
    totalAmount,
    // 추가 정보
    notes: quoteData.description,
    isContracted: quoteData.isContracted,
    pdfUrl: quoteData.pdfUrl,
    attachments: mapAttachments(quoteData.attachments),
    // 견적서 서식은 공급사별로 고정 배정 — PDF·미리보기가 같은 id 로 같은 템플릿이 된다.
    templateId: pickQuoteTemplateId(quoteData.supplier?.id ?? null)
  };
}
function mapQuoteDataToQuotePdfData(quoteData, messageId, createdAt, options) {
  return mapQuoteMessageToQuotePdfData(
    { id: messageId, createdAt, quoteData },
    options
  );
}

// src/utils/mapContractData.ts
var defaultOptions2 = {
  dateFormatter: formatDateKorean
};
function mapProvider2(supplier) {
  return {
    companyName: supplier?.name ?? "\uC5C5\uCCB4\uBA85 \uBBF8\uC785\uB825",
    representativeName: supplier?.ceoName ?? "-",
    businessNumber: supplier?.businessNumber ?? "-",
    address: supplier?.address ?? "-",
    phoneNumber: supplier?.phone,
    email: supplier?.email,
    businessType: supplier?.businessType,
    businessCategory: supplier?.businessCategory,
    managerName: supplier?.managerName,
    managerPhone: supplier?.managerPhone,
    companySealUrl: supplier?.companySealUrl
  };
}
function mapBuyer2(buyer, deliveryAddress) {
  const formattedAddress = deliveryAddress ? [
    formatAddressLine(deliveryAddress),
    deliveryAddress.addressDetail ? `(${deliveryAddress.addressDetail})` : ""
  ].filter(Boolean).join(" ") : void 0;
  return {
    // 비었을 때 «발주기관» — 견적서 PDF(서버)와 같은 대체 이름(GS A5-07).
    companyName: buyer?.company ?? buyer?.name ?? "\uBC1C\uC8FC\uAE30\uAD00",
    contactName: buyer?.name,
    // 대표자·사업자번호·기관 주소 — PDF 본문(ContractRecipientAmount)이 그리는 값과 동일.
    // 미리보기와 실제 PDF 가 다른 상대를 보여주면 안 된다.
    representativeName: buyer?.representativeName,
    businessNumber: buyer?.businessNumber,
    address: buyer?.address,
    phoneNumber: buyer?.phone,
    email: buyer?.email,
    deliveryAddress: formattedAddress
  };
}
function mapItems2(items) {
  if (!items || items.length === 0) {
    return [];
  }
  return items.map((item) => ({
    name: item.name ?? "\uD488\uBA85 \uBBF8\uC785\uB825",
    quantity: item.quantity ?? 0,
    unit: item.unit ?? "\uAC1C",
    unitPrice: item.unitPrice ?? 0,
    amount: item.amount ?? (item.quantity ?? 0) * (item.unitPrice ?? 0),
    spec1: item.spec1,
    spec2: item.spec2,
    spec3: item.spec3,
    description: item.description
  }));
}
function mapContractToContractPdfData(contract, options) {
  const opts = { ...defaultOptions2, ...options };
  const totalAmount = contract.totalAmount ?? 0;
  const { subtotal, tax } = calculateFromTotal(totalAmount);
  return {
    // 기본 정보
    contractNumber: contract.contractNumber ?? "-",
    contractDate: contract.createdAt ? opts.dateFormatter(contract.createdAt) : "-",
    categoryType: contract.categoryType,
    // 결제 정보
    paymentTransactionId: contract.paymentTransactionId,
    paymentApprovedAt: contract.paymentApprovedAt ? opts.dateFormatter(contract.paymentApprovedAt) : void 0,
    // 공급자/수신자
    supplier: mapProvider2(contract.supplier),
    buyer: mapBuyer2(contract.buyer, contract.deliveryAddress),
    // 품목
    items: mapItems2(contract.items),
    // 금액
    subtotal,
    tax,
    totalAmount,
    // 추가 정보
    notes: contract.notes
  };
}
export {
  CancellationConfirmationPdfDocument,
  ContractHeader,
  ContractItemsTable,
  ContractNotesGrid,
  ContractPdfDocument,
  ContractProviderTable,
  ContractRecipientAmount,
  ContractSummary,
  MaskedSectionInline,
  PdfDocument,
  PdfHeader,
  PdfInfoRow,
  PdfSection,
  PdfSummary,
  PdfTable,
  QUOTE_TEMPLATES,
  QuoteBuyerInfo,
  QuoteItemsTable,
  QuotePdfDocument,
  QuoteProviderInfo,
  QuoteProviderTable,
  SealImage,
  baseStyles,
  calculateFromTotal,
  calculateVAT,
  colors,
  convertNumberToKorean,
  formatAddressLine,
  formatAmountWithKorean,
  formatBusinessNumber,
  formatCurrency,
  formatCurrencyWithUnit,
  formatDateISO,
  formatDateKorean,
  formatDateSlash,
  formatPhoneNumber,
  getQuoteTheme,
  innopayStyles,
  mapContractToContractPdfData,
  mapQuoteDataToQuotePdfData,
  mapQuoteMessageToQuotePdfData,
  pickQuoteTemplateId,
  renderToHtml,
  renderToHtmlFragment
};
//# sourceMappingURL=index.js.map